<template>
  <page-view v-if="!isMobileBreakpoint" :is-loading="loading" fill-height>
    <template #header>
      <base-header
        :title="$t('message.pages.funnel.titleIntern')"
        :subtitle="funnelName"
        @title="handleBackToListing"
        @back="handleBackToListing"
        :isMobileBreakpoint="isMobileBreakpoint"
      >
        <template #actions>
          <span style="display: flex; align-items: center">
            <!-- <v-switch
              :disabled="!funnelVideosLength"
              v-model="isAnalyticsEnabled"
              class="mt-0"
              :label="'Analytics'"
              hide-details
            /> -->
            <base-btn
              @click="handlePreview"
              type="neutral"
              :tooltip="
                !droppedItems.length
                  ? $t('message.pages.funnel.toasts.notShowView')
                  : undefined
              "
              style="margin-left: 1rem"
              :disabled="!droppedItems.length"
            >
              {{ $t('message.pages.funnel.view') }}
            </base-btn>
            <base-btn
              @click="handleShare"
              :tooltip="
                !droppedItems.length
                  ? $t('message.pages.funnel.toasts.notShowEmbed')
                  : undefined
              "
              type="tertiary"
              style="margin-left: 1rem"
              :disabled="!droppedItems.length"
            >
              Embed
            </base-btn>
            <v-tooltip
              max-width="184px"
              bottom
              :disabled="!hasSaved && droppedItems.length"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    style="margin-left: 1rem"
                    :loading="loadingSave"
                    @click="saveFunnel"
                    :disabled="!droppedItems.length || hasSaved"
                  >
                    {{ $t('message.actions.save') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
          </span>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="iconElement" icon v-bind="attrs" v-on="on">
                <v-icon small>panda-menu-action</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="handleEditGroup" :disabled="loadingSave">
                <span class="body-regular-smaller">
                  {{ $t('message.pages.pandaAssist.renameModal.button') }}
                </span>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item @click="handleDeleteGroup" :disabled="loadingSave">
                <span
                  class="body-regular-smaller"
                  style="height: 100%; color: #f44336"
                >
                  {{ $t('message.remove') }}
                </span>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </base-header>
    </template>
    <template #content>
      <div
        v-if="funnelVideosLength === 0 && droppedItems.length === 0"
        class="empty-state"
        :class="[{ 'dragable-area-active': isDragging }]"
        @dragover.prevent="handleDragOver"
        @dragleave="handleDragLeave"
        @drop="handleDrop"
        @click="handleCloseMenu()"
      >
        <div
          class="d-flex flex-column align-center"
          style="margin-bottom: 100px; margin-right: 100px"
        >
          <img
            class="emptyStateTitle mb-4"
            src="@/assets/videosEmptyState.svg"
            max-width="240"
          />
          <span class="body-regular-large neutral-20-dark--text">
            {{ $t('message.pages.funnel.emptyStateEdit.title') }}
          </span>
          <span class="body-regular-small neutral2-40light--text mb-4">
            {{ $t('message.pages.funnel.emptyStateEdit.description') }}
          </span>
          <base-btn
            size="small"
            :loading="loadingSave"
            :disabled="loadingSave"
            @click.stop="handleOpenAddVideo()"
          >
            {{ $t('message.pages.funnel.emptyStateEdit.addVideo') }}
          </base-btn>
        </div>
      </div>
      <div
        v-if="isAnalyticsEnabled"
        class="d-flex justify-center"
        style="
          gap: 20px;
          background: #fff;
          padding-top: 20px;
          padding-bottom: 20px;
          z-index: 9999;
          width: 100%;
          top: 56px;
          position: absolute;
        "
      >
        <div style="width: 200px">
          <v-select
            v-model="selectedPeriod"
            :items="periods"
            class="custom-select"
            hide-details
            outlined
          >
            <template v-slot:selection="data">
              <span class="d-flex">
                <img
                  src="@/assets/analyticsDropdown_funnel.svg"
                  alt="Icon"
                  class="mr-2"
                />
                {{ data.item }}
              </span>
            </template>
          </v-select>
        </div>
        <div
          v-for="metric in metrics"
          :key="metric.title"
          class="analytics-container"
          style="display: grid"
        >
          <div class="analytics-firstLine">
            <span class="analytics-title"> {{ metric.title }} </span>
            <span :class="getMetricClass(metric.value)">
              <v-icon size="16"> {{ getMetricIcon(metric.value) }} </v-icon>
              <span> {{ metric.percentage }} </span>
            </span>
          </div>
          <span class="analytics-data"> {{ metric.data }} </span>
        </div>
      </div>
      <v-app
        v-if="
          !loading && (funnelVideosLength !== 0 || droppedItems.length !== 0)
        "
        class="main-content"
      >
        <div v-show="!loading" class="content-wrapper drag-drop-container">
          <div class="funnel-container">
            <div
              :style="zoomStyle"
              class="zoom-container"
              @wheel="handleWheelEvent"
            >
              <div
                :class="[
                  'dragable-area',
                  { 'dragable-area-active': isDragging },
                ]"
                @dragover.prevent="handleDragOver"
                @dragleave="handleDragLeave"
                @drop="handleDrop"
                @click="closeMenuWithoutDelay"
              >
                <div
                  class="watching-preview-overlay"
                  @click="toggleWatchingPreview()"
                  v-if="watchingPreview"
                  style="
                    position: fixed;
                    top: -2500px;
                    left: -2500px;
                    background: rgba(0, 0, 0, 0.7);
                    z-index: 899;
                  "
                ></div>
                <div
                  v-if="isOverlayVisible"
                  class="overlay"
                  @click="deselectItem"
                ></div>
                <div v-if="showMenuEmbed" class="embed-overlay"></div>
                <embed-video
                  style="z-index: 1001 !important; overflow: hidden"
                  v-if="showMenuEmbed"
                  :startTime="startTime"
                  :timeVideo="timeVideo"
                  :videoId="videoId"
                  :showMenuEmbed="showMenuEmbed"
                  :embedSelected="embedSelected"
                  :showMenuPosition="menuPosition"
                  :fetching="isLoading"
                  :video="video"
                  :isExternalSourceVideo="isExternalSourceVideo"
                  @start-time="startTime = $event"
                  @showEmbed="(val) => (showMenuEmbed = val)"
                  @embed="handleEmbedEmit"
                  @playOpensFullscreen="handlePlayOpensFullscreen"
                  @preloadEmbed="preloadEmbed = $event"
                />
                <div
                  v-for="(item, index) in droppedItems"
                  :key="index"
                  class="dropped-item"
                  :class="{
                    selected: isSelected(index),
                    highlighted: item.highlighted,
                  }"
                  style="display: grid"
                  :style="{
                    left: item.x + 'px',
                    top: item.y + 'px',
                    zIndex: isAnalyticsEnabled ? '1' : '0x',
                  }"
                  ref="droppedItem"
                  @click="selectItem(index)"
                >
                  <div
                    class="d-flex border-bottom preview-anchor"
                    ref="previewAnchor"
                    style="width: 100%; max-height: 124px"
                  >
                    <v-col
                      :class="item.is_first ? 'brand-95-lighter' : 'neutral-99'"
                      style="
                        padding: 22px;
                        padding-top: 12px;
                        border-top-left-radius: 16px;
                        display: flex;
                        align-items: center;
                      "
                      :style="{
                        paddingTop: item.is_first ? '12px' : '24px',
                        flexDirection: item.is_first ? 'column' : 'row',
                      }"
                      cols="5"
                    >
                      <span
                        class="initial-span-video mb-2"
                        v-if="item.is_first"
                      >
                        {{ $t('message.pages.funnel.newFunnel.initialVideo') }}
                      </span>
                      <span
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          justify-content: center;
                          background: #ebeeff;
                          width: 174px;
                          height: 76px;
                        "
                        :style="{
                          width: item.is_first ? 'auto' : '174px',
                        }"
                      >
                        <img
                          v-if="
                            item.status !== 'DRAFT' &&
                            item.status !== 'CONVERTING'
                          "
                          width="150"
                          height="100%"
                          :src="
                            item.preview
                              ? item.preview
                              : '@/assets/empty-preview.svg'
                          "
                          alt="Video"
                        />
                        <span class="d-flex justify-center align-center" v-else>
                          <img
                            width="150"
                            src="@/assets/empty-preview.svg"
                            alt="Video"
                            height="54px"
                          />
                          <v-tag style="position: absolute">{{
                            $t('message.pages.funnel.newFunnel.converting')
                          }}</v-tag>
                          <!-- <span class="loader loader-one"></span> -->
                        </span>
                      </span>
                    </v-col>
                    <v-col
                      style="
                        display: flex;
                        justify-content: space-between;
                        overflow: hidden;
                      "
                      cols="7"
                    >
                      <div style="display: grid; justify-content: center">
                        <span class="video-title">
                          {{ item.name || item.title }}
                        </span>
                        <span
                          v-if="
                            item.status !== 'DRAFT' &&
                            item.status !== 'CONVERTING'
                          "
                        >
                          <v-tag type="neutral">{{
                            formatTime(item.length)
                          }}</v-tag>
                        </span>
                        <span v-else class="d-flex lenghtConvertingText">
                          <span>{{
                            $t('message.pages.funnel.newFunnel.converting')
                          }}</span>
                          <span class="loader loader-two"></span>
                        </span>
                      </div>
                      <div class="menu-item">
                        <v-menu
                          ref="menus"
                          class="dropped-menu"
                          max-width="200px"
                          min-width="180px"
                          right
                          bottom
                          v-model="item.menu"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on"
                              >mdi-dots-vertical</v-icon
                            >
                          </template>
                          <v-list>
                            <v-list-item
                              class="border-bottom"
                              @click="editVideo(item)"
                            >
                              <img class="ml-2 mr-2" src="" />
                              <v-list-item-title class="body-regular-smaller">{{
                                $t('message.pages.funnel.newFunnel.editVideo')
                              }}</v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item
                              @click="isAnalyticsEnabled = !isAnalyticsEnabled"
                            >
                              <img class="ml-2 mr-2" src="" />
                              <v-list-item-title class="body-regular-smaller">{{
                                $t('message.pages.funnel.newFunnel.seeData')
                              }}</v-list-item-title>
                            </v-list-item> -->
                            <v-list-item
                              :disabled="loadingSave"
                              @click="
                                confirmRemoveVideo(item, $refs.menus[index])
                              "
                            >
                              <img class="ml-2 mr-2" src="" />
                              <v-list-item-title
                                class="body-regular-smaller feedback-danger--text"
                                >{{
                                  $t('message.pages.funnel.newFunnel.remove')
                                }}</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-col>
                  </div>
                  <div
                    @mouseenter="showPlusIndex = index"
                    @mouseleave="showPlusIndex = null"
                    class="d-flex link-anchor"
                    ref="linkAnchor"
                  >
                    <v-col
                      class="d-flex cta-title"
                      cols="5"
                      style="align-items: center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M16 21.7998V19.7998C16 19.358 16.358 19 16.7998 19C17.2416 19 17.5996 19.358 17.5996 19.7998V21.7998C17.5996 22.2416 17.2416 22.5996 16.7998 22.5996C16.358 22.5996 16 22.2416 16 21.7998ZM16 15.7998V13.7998C16 13.358 16.358 13 16.7998 13C17.2416 13 17.5996 13.358 17.5996 13.7998V15.7998C17.5996 16.2416 17.2416 16.5996 16.7998 16.5996C16.358 16.5996 16 16.2416 16 15.7998ZM9.23438 8.23438C9.52733 7.94142 9.99046 7.92322 10.3047 8.17969L10.3652 8.23438L13.3652 11.2344C13.6777 11.5468 13.6777 12.0528 13.3652 12.3652L10.3652 15.3652C10.0528 15.6777 9.54679 15.6777 9.23438 15.3652C8.92196 15.0528 8.92196 14.5468 9.23438 14.2344L10.8691 12.5996H6.7998C6.35798 12.5996 6 12.2416 6 11.7998C6 11.358 6.35798 11 6.7998 11H10.8691L9.23438 9.36523L9.17969 9.30469C8.92323 8.99047 8.94142 8.52733 9.23438 8.23438ZM16 9.7998V7.7998C16 7.35798 16.358 7 16.7998 7C17.2416 7 17.5996 7.35798 17.5996 7.7998V9.7998C17.5996 10.2416 17.2416 10.5996 16.7998 10.5996C16.358 10.5996 16 10.2416 16 9.7998ZM16 3.7998V1.7998C16 1.35798 16.358 1 16.7998 1C17.2416 1 17.5996 1.35798 17.5996 1.7998V3.7998C17.5996 4.24163 17.2416 4.59961 16.7998 4.59961C16.358 4.59961 16 4.24163 16 3.7998Z"
                          :fill="!$vuetify.theme.dark ? '#636578' : '#B9BBC6'"
                        />
                      </svg>
                      {{ $t('message.pages.funnel.newFunnel.endVideo') }}
                    </v-col>
                    <v-col class="cta-action" cols="7">
                      <span
                        v-if="item.hasEndRedirect"
                        class="mr-3 brand-60-base--text"
                      >
                        {{ item.nameVideoLinked }}
                      </span>
                      <span v-else-if="item.hasEndRestart" class="mr-3">{{
                        $t('message.pages.funnel.newFunnel.restartVideo')
                      }}</span>
                      <span v-else class="neutral-30-base--text pr-5">
                        {{ $t('message.pages.funnel.newFunnel.doNothing') }}
                      </span>
                    </v-col>
                    <span
                      v-if="
                        !item.hasEndRedirect &&
                        showPlusIndex == index &&
                        !loadingSave
                      "
                      @click.stop="selectForLinking(item)"
                      class="link-plus-icon"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.833 4.16683C10.833 3.70659 10.4599 3.3335 9.99967 3.3335C9.53944 3.3335 9.16634 3.70659 9.16634 4.16683V9.16683H4.16634C3.7061 9.16683 3.33301 9.53993 3.33301 10.0002C3.33301 10.4604 3.7061 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.2937 9.53944 16.6668 9.99967 16.6668C10.4599 16.6668 10.833 16.2937 10.833 15.8335V10.8335H15.833C16.2932 10.8335 16.6663 10.4604 16.6663 10.0002C16.6663 9.53993 16.2932 9.16683 15.833 9.16683H10.833V4.16683Z"
                          :fill="!$vuetify.theme.dark ? '#3F404C' : '#C2C5D6'"
                        />
                      </svg>
                    </span>
                    <div
                      class="line-analytics"
                      v-if="
                        item.linkedToRight &&
                        isAnalyticsEnabled &&
                        !isOverlayVisible &&
                        item.hasEndRedirect
                      "
                    >
                      <div class="tooltip">
                        {{ getViewDifference(item) }}
                        {{ $t('message.pages.funnel.newFunnel.access') }} ({{
                          getPercentageDifference(item)
                        }}%)
                        {{
                          $t('message.pages.funnel.newFunnel.nextInteraction')
                        }}
                      </div>
                      <div class="line-analytics-value">
                        <span> {{ getViewDifference(item) }} </span>
                      </div>
                      <div class="line-analytics-percent">
                        <span> {{ getPercentageDifference(item) }}% </span>
                      </div>
                    </div>
                  </div>
                  <v-divider
                    v-if="item.hasForm"
                    class="internal-divider"
                  ></v-divider>
                  <div
                    v-if="item.hasForm"
                    style="
                      align-items: center;
                      display: flex;
                      justify-content: space-between;
                    "
                    class="d-flex link-anchor"
                    ref="linkAnchor"
                  >
                    <v-col class="d-flex align-center cta-title" cols="4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        style="margin-right: 2px"
                      >
                        <path
                          d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
                          :stroke="!$vuetify.theme.dark ? '#636578' : '#B9BBC6'"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 7L13.03 12.7C12.7213 12.8934 12.3643 12.996 12 12.996C11.6357 12.996 11.2787 12.8934 10.97 12.7L2 7"
                          :stroke="!$vuetify.theme.dark ? '#636578' : '#B9BBC6'"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      LEAD
                    </v-col>
                    <div v-if="integrationLength === 1">
                      <v-col
                        v-if="integrations[0] === 'mailchimp'"
                        class="cta-action"
                        cols="12"
                      >
                        <span class="mr-3">
                          {{
                            $t('message.pages.funnel.newFunnel.integratedWith')
                          }}
                        </span>
                        <div class="mx-2 mailchimp-container">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="114"
                            height="32"
                            viewBox="0 0 114 32"
                            fill="none"
                          >
                            <path
                              d="M47.2029 13.2007C46.1111 13.2007 45.5715 14.0595 45.3237 14.6138C45.1851 14.9235 45.1463 15.1681 45.034 15.1681C44.8754 15.1681 44.9888 14.9561 44.8597 14.4836C44.6896 13.8632 44.1762 13.2007 43.0854 13.2007C41.939 13.2007 41.4477 14.1697 41.2146 14.702C41.055 15.0663 41.055 15.1681 40.9333 15.1681C40.7558 15.1681 40.9028 14.8794 40.9826 14.5393C41.1401 13.8705 41.0204 13.3582 41.0204 13.3582H39.2031V20.1939H41.6839V16.7933C41.6839 16.1225 41.9642 15.271 42.445 15.271C43.0004 15.271 43.1117 15.6973 43.1117 16.4878V20.1949H45.603V16.7923C45.603 16.1949 45.8465 15.27 46.3683 15.27C46.9321 15.27 47.0318 15.8695 47.0318 16.4868V20.1928H49.4779V16.1729C49.4779 14.3902 48.8491 13.2007 47.2029 13.2007Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M89.3173 13.2007C88.2254 13.2007 87.6858 14.0595 87.438 14.6138C87.2995 14.9235 87.2606 15.1681 87.1483 15.1681C86.9898 15.1681 87.0958 14.8983 86.974 14.4836C86.7924 13.8663 86.3399 13.2007 85.1998 13.2007C84.0534 13.2007 83.562 14.1697 83.329 14.702C83.1694 15.0663 83.1694 15.1681 83.0476 15.1681C82.8702 15.1681 83.0172 14.8794 83.0969 14.5393C83.2544 13.8705 83.1347 13.3582 83.1347 13.3582H81.3164V20.1939H83.7972V16.7933C83.7972 16.1225 84.0775 15.271 84.5583 15.271C85.1137 15.271 85.225 15.6973 85.225 16.4878V20.1949H87.7163V16.7923C87.7163 16.1949 87.9598 15.27 88.4816 15.27C89.0454 15.27 89.1451 15.8695 89.1451 16.4868V20.1928H91.5912V16.1729C91.5923 14.3902 90.9634 13.2007 89.3173 13.2007Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M53.1113 18.5963C52.5181 18.7339 52.2105 18.5501 52.2105 18.1575C52.2105 17.6189 52.768 17.4026 53.5627 17.4026C53.9134 17.4026 54.243 17.4331 54.243 17.4331C54.243 17.664 53.7433 18.4514 53.1113 18.5963ZM53.716 13.2031C51.8158 13.2031 50.452 13.9023 50.452 13.9023V15.9559C50.452 15.9559 51.9586 15.0897 53.1795 15.0897C54.1548 15.0897 54.2745 15.6157 54.2304 16.0525C54.2304 16.0525 53.9491 15.9779 53.0913 15.9779C51.0693 15.9779 50.0479 16.8966 50.0479 18.3706C50.0479 19.769 51.1953 20.3528 52.1622 20.3528C53.5732 20.3528 54.1926 19.4047 54.3837 18.9554C54.516 18.6436 54.5401 18.4336 54.6588 18.4336C54.7942 18.4336 54.749 18.5848 54.7417 18.8945C54.7302 19.4383 54.7553 19.8488 54.8425 20.1953H56.7112V16.8315C56.7112 14.7317 55.9679 13.2031 53.716 13.2031Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M60.7969 20.1951H63.2777V11.2891H60.7969V20.1951Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M66.0088 16.7775C66.0088 16.1634 66.5799 15.6038 67.6276 15.6038C68.7699 15.6038 69.6885 16.1539 69.8942 16.2788V13.9009C69.8942 13.9009 69.1688 13.2017 67.3851 13.2017C65.5048 13.2017 63.9385 14.3019 63.9385 16.6704C63.9385 19.039 65.36 20.3523 67.3799 20.3523C68.9578 20.3523 69.8984 19.4851 69.8984 19.4851V17.2269C69.6013 17.3938 68.772 17.9691 67.6392 17.9691C66.4403 17.9702 66.0088 17.4179 66.0088 16.7775Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M74.9215 13.2029C73.4853 13.2029 72.9383 14.5646 72.8281 14.8008C72.7178 15.037 72.6633 15.1735 72.573 15.1704C72.4165 15.1651 72.5257 14.8806 72.5866 14.6958C72.7021 14.3473 72.9467 13.4328 72.9467 12.3084C72.9467 11.5462 72.8438 11.29 72.8438 11.29H70.7021V20.1951H73.1829V16.7945C73.1829 16.2402 73.4044 15.2722 74.0291 15.2722C74.5467 15.2722 74.7094 15.6554 74.7094 16.4281V20.1951H77.1902V16.5772C77.1912 14.8229 76.9004 13.2029 74.9215 13.2029Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M77.9971 13.3677V20.195H80.4778V13.3677C80.4778 13.3677 80.0611 13.6112 79.2401 13.6112C78.4191 13.6112 77.9971 13.3677 77.9971 13.3677Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M79.232 11.2197C78.3932 11.2197 77.7129 11.6638 77.7129 12.2108C77.7129 12.7578 78.3932 13.2019 79.232 13.2019C80.0708 13.2019 80.7511 12.7578 80.7511 12.2108C80.7501 11.6638 80.0708 11.2197 79.232 11.2197Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M57.5117 13.3677V20.195H59.9925V13.3677C59.9925 13.3677 59.5757 13.6112 58.7547 13.6112C57.9338 13.6112 57.5117 13.3677 57.5117 13.3677Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M58.7467 11.2197C57.9078 11.2197 57.2275 11.6638 57.2275 12.2108C57.2275 12.7578 57.9078 13.2019 58.7467 13.2019C59.5855 13.2019 60.2658 12.7578 60.2658 12.2108C60.2658 11.6638 59.5855 11.2197 58.7467 11.2197Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M95.8421 18.7262C95.2731 18.7262 94.8542 18.0049 94.8542 16.9991C94.8542 16.0227 95.2847 15.2721 95.8222 15.2721C96.513 15.2721 96.807 15.9052 96.807 16.9991C96.807 18.1372 96.5361 18.7262 95.8421 18.7262ZM96.5235 13.2007C95.2479 13.2007 94.6632 14.1571 94.4091 14.702C94.2411 15.0621 94.2495 15.1681 94.1267 15.1681C93.9493 15.1681 94.0963 14.8794 94.176 14.5393C94.3335 13.8705 94.2138 13.3582 94.2138 13.3582H92.3955V22.0816H94.8763V19.3162C95.1702 19.8138 95.7141 20.3461 96.5518 20.3461C98.346 20.3461 99.2489 18.828 99.2489 16.7766C99.251 14.4521 98.1696 13.2007 96.5235 13.2007Z"
                              fill="#100F0D"
                            />
                            <path
                              d="M30.4373 15.2659C30.6042 15.2459 30.7638 15.2449 30.9108 15.2659C30.9958 15.0706 31.0105 14.7347 30.9339 14.3693C30.8205 13.8255 30.6662 13.4958 30.3481 13.5473C30.03 13.5987 30.0184 13.9924 30.1318 14.5362C30.1969 14.8417 30.3103 15.1042 30.4373 15.2659Z"
                              fill="#231F20"
                            />
                            <path
                              d="M27.7071 15.6964C27.9349 15.7961 28.0746 15.8622 28.1292 15.8045C28.1649 15.7688 28.1544 15.6995 28.0998 15.6113C27.9874 15.4276 27.7565 15.2418 27.5119 15.1378C27.0111 14.9226 26.4137 14.994 25.9518 15.3247C25.7996 15.436 25.6557 15.5903 25.6757 15.6848C25.682 15.7153 25.7051 15.7384 25.7586 15.7457C25.8846 15.7604 26.3224 15.5378 26.8274 15.5074C27.1843 15.4853 27.4804 15.5966 27.7071 15.6964Z"
                              fill="#231F20"
                            />
                            <path
                              d="M27.2497 15.9579C26.9537 16.0051 26.7899 16.1028 26.6849 16.1931C26.5957 16.2708 26.54 16.3579 26.54 16.4188C26.54 16.4482 26.5526 16.4639 26.5631 16.4723C26.5768 16.4839 26.5925 16.4912 26.6114 16.4912C26.6786 16.4912 26.8277 16.4314 26.8277 16.4314C27.2403 16.2834 27.5122 16.3023 27.781 16.3327C27.93 16.3495 28.0004 16.359 28.0329 16.3075C28.0424 16.2928 28.0539 16.2613 28.0245 16.213C27.9573 16.0996 27.6581 15.9096 27.2497 15.9579Z"
                              fill="#231F20"
                            />
                            <path
                              d="M29.5144 16.9164C29.716 17.015 29.9365 16.9762 30.0089 16.8292C30.0813 16.6822 29.9764 16.4838 29.7748 16.3851C29.5732 16.2864 29.3528 16.3253 29.2803 16.4723C29.2089 16.6182 29.3129 16.8166 29.5144 16.9164Z"
                              fill="#231F20"
                            />
                            <path
                              d="M30.8093 15.7852C30.6455 15.782 30.5101 15.9616 30.5069 16.1862C30.5027 16.4109 30.6329 16.5946 30.7956 16.5967C30.9594 16.5999 31.0948 16.4204 31.098 16.1957C31.1022 15.9721 30.972 15.7883 30.8093 15.7852Z"
                              fill="#231F20"
                            />
                            <path
                              d="M19.8332 19.8266C19.7922 19.7751 19.7261 19.7909 19.661 19.8066C19.6159 19.8171 19.5644 19.8287 19.5088 19.8276C19.3891 19.8255 19.2873 19.7741 19.2295 19.6859C19.155 19.5714 19.1592 19.4014 19.2411 19.2061C19.2526 19.1798 19.2652 19.1504 19.2799 19.1189C19.4111 18.825 19.6306 18.3326 19.3838 17.8633C19.198 17.5105 18.8957 17.2901 18.5324 17.2439C18.1839 17.1998 17.8238 17.3289 17.5949 17.5819C17.2338 17.9809 17.1771 18.5237 17.2464 18.7158C17.2716 18.7861 17.3125 18.805 17.3409 18.8092C17.4028 18.8176 17.4931 18.7725 17.5498 18.6192C17.554 18.6087 17.5592 18.5909 17.5666 18.5699C17.5918 18.489 17.639 18.3378 17.7167 18.2171C17.8101 18.0712 17.955 17.9704 18.1261 17.9347C18.3004 17.8979 18.4778 17.9305 18.6269 18.0281C18.8799 18.194 18.9776 18.5037 18.8694 18.7998C18.8138 18.9531 18.7224 19.246 18.7424 19.4864C18.7833 19.9735 19.0825 20.1688 19.3513 20.1898C19.6127 20.1993 19.7954 20.0533 19.8416 19.9452C19.871 19.8822 19.8479 19.8434 19.8332 19.8266Z"
                              fill="#231F20"
                            />
                            <path
                              d="M22.3194 10.8823C23.1729 9.89651 24.2228 9.03877 25.1645 8.55793C25.197 8.54113 25.2317 8.57682 25.2138 8.60832C25.1393 8.74375 24.9955 9.03352 24.9493 9.25294C24.9419 9.28759 24.9797 9.31278 25.0081 9.29284C25.5939 8.89388 26.6122 8.46659 27.5046 8.41094C27.5434 8.40884 27.5613 8.45819 27.5308 8.48128C27.3954 8.58522 27.2463 8.7301 27.1382 8.87604C27.1193 8.90123 27.1371 8.93693 27.1676 8.93693C27.7943 8.94113 28.6794 9.16055 29.2557 9.48391C29.2946 9.50596 29.2673 9.58155 29.2232 9.57105C28.3508 9.37158 26.924 9.21935 25.4416 9.58155C24.1178 9.90491 23.1078 10.4026 22.3708 10.939C22.3341 10.9663 22.289 10.918 22.3194 10.8823ZM26.5692 20.4362C26.5692 20.4372 26.5702 20.4372 26.5702 20.4383C26.5692 20.4372 26.5692 20.4372 26.5692 20.4362ZM30.0882 20.8519C30.1134 20.8414 30.1313 20.812 30.1281 20.7837C30.125 20.748 30.0935 20.7228 30.0578 20.7259C30.0578 20.7259 28.2363 20.9958 26.5167 20.3658C26.7036 19.7569 27.2022 19.9763 27.955 20.0372C29.3124 20.1181 30.5292 19.9196 31.4278 19.6614C32.2068 19.4378 33.2304 18.9968 34.0252 18.37C34.2929 18.959 34.3884 19.6068 34.3884 19.6068C34.3884 19.6068 34.5963 19.57 34.7695 19.6761C34.9333 19.7769 35.054 19.9868 34.9711 20.5286C34.8041 21.5417 34.3737 22.3627 33.6504 23.1186C33.2105 23.5921 32.6751 24.0047 32.0641 24.3039C31.7314 24.4783 31.3848 24.6248 31.0279 24.7417C28.3004 25.632 25.5099 24.6535 24.6102 22.5506C24.5388 22.3921 24.4779 22.2273 24.4296 22.054C24.0464 20.6682 24.3719 19.0063 25.3891 17.9595V17.9585C25.4521 17.8923 25.5162 17.8136 25.5162 17.7149C25.5162 17.632 25.4637 17.5448 25.4185 17.4829C25.0626 16.9664 23.8291 16.0866 24.0768 14.3837C24.2543 13.1606 25.3241 12.2986 26.3214 12.3501C26.4054 12.3543 26.4904 12.3595 26.5744 12.3648C27.007 12.39 27.3839 12.4456 27.7397 12.4603C28.335 12.4865 28.8704 12.3994 29.5056 11.8713C29.7198 11.6928 29.8909 11.5385 30.1817 11.4892C30.2121 11.4839 30.2877 11.4566 30.4399 11.464C30.5943 11.4724 30.7423 11.5144 30.8746 11.6026C31.3827 11.9406 31.4551 12.7606 31.4814 13.36C31.4961 13.7023 31.5381 14.5307 31.5517 14.7679C31.5843 15.3118 31.7271 15.3884 32.0158 15.4829C32.1785 15.5364 32.3297 15.5763 32.5512 15.6383C33.2241 15.8272 33.6231 16.0194 33.875 16.265C34.0252 16.4194 34.0944 16.5821 34.1165 16.7385C34.1963 17.3181 33.6672 18.033 32.2667 18.6829C30.736 19.3937 28.8788 19.5732 27.5959 19.4304C27.4972 19.4199 27.1476 19.38 27.1466 19.38C26.1198 19.2414 25.5351 20.5685 26.1513 21.4766C26.5482 22.0624 27.6295 22.4435 28.7109 22.4435C31.1916 22.4435 33.0971 21.3842 33.8068 20.4698C33.8278 20.4425 33.8299 20.4393 33.8635 20.3889C33.8981 20.3364 33.8698 20.307 33.8257 20.3375C33.2462 20.7343 30.673 22.3081 27.9203 21.8346C27.9203 21.8346 27.5854 21.78 27.281 21.6614C27.0385 21.5669 26.5303 21.3338 26.4684 20.812C28.6888 21.5018 30.0882 20.8519 30.0882 20.8519ZM17.8859 15.5721C17.1132 15.7223 16.4319 16.1601 16.0161 16.7648C15.7673 16.5569 15.3033 16.1559 15.2214 15.9984C14.5569 14.7364 15.9469 12.2818 16.918 10.896C19.319 7.47131 23.0784 4.87917 24.818 5.34952C25.1015 5.42931 26.038 6.51592 26.038 6.51592C26.038 6.51592 24.2984 7.48076 22.6858 8.82669C20.5116 10.5002 18.8696 12.9327 17.8859 15.5721ZM19.1846 21.3653C19.068 21.3853 18.9484 21.3937 18.8276 21.3905C17.6655 21.359 16.4098 20.3123 16.2849 19.0713C16.1474 17.6992 16.8476 16.644 18.0885 16.3931C18.2366 16.3637 18.4161 16.3459 18.6093 16.3564C19.3043 16.3942 20.3289 16.9286 20.563 18.4435C20.7719 19.7842 20.4423 21.1501 19.1846 21.3653ZM34.9312 18.9359C34.9217 18.9002 34.8566 18.664 34.7674 18.3774C34.6782 18.0918 34.5858 17.8902 34.5858 17.8902C34.9438 17.3548 34.9501 16.8761 34.9018 16.6052C34.8514 16.2692 34.7107 15.9826 34.4293 15.6866C34.1469 15.3905 33.5706 15.0871 32.7601 14.8593C32.6677 14.833 32.3622 14.749 32.3349 14.7417C32.3328 14.7238 32.3129 13.739 32.294 13.3159C32.2803 13.0104 32.2541 12.5327 32.106 12.0624C31.9297 11.4262 31.6221 10.8697 31.2389 10.5128C32.2982 9.41462 32.9596 8.20517 32.9575 7.16789C32.9543 5.17209 30.504 4.56841 27.4846 5.81881C27.4815 5.81986 26.8495 6.08863 26.8453 6.09073C26.8421 6.08758 25.6884 4.95581 25.6716 4.94111C22.2281 1.93953 11.463 13.9049 14.9044 16.811L15.6561 17.4482C15.4608 17.9532 15.3841 18.5328 15.4471 19.1553C15.528 19.9553 15.9406 20.7217 16.6083 21.3139C17.2434 21.8766 18.078 22.2325 18.8875 22.2315C20.2271 25.3181 23.2874 27.211 26.8747 27.3181C30.7234 27.4325 33.9538 25.6268 35.3081 22.3826C35.3963 22.1548 35.7721 21.1291 35.7721 20.2231C35.7742 19.3128 35.2587 18.9359 34.9312 18.9359Z"
                              fill="#231F20"
                            />
                          </svg>
                        </div>
                      </v-col>
                      <v-col
                        v-if="integrations[0] === 'active_campaign'"
                        class="cta-action px-0"
                        cols="12"
                      >
                        <span class="mr-3">
                          {{
                            $t('message.pages.funnel.newFunnel.integratedWith')
                          }}
                        </span>
                        <img
                          height="35"
                          class="mr-2"
                          src="@/assets/activecampaign.svg"
                        />
                      </v-col>
                      <v-col
                        v-if="integrations[0] === 'webhook'"
                        class="cta-action px-0"
                        cols="12"
                      >
                        <span class="mr-3">
                          {{
                            $t('message.pages.funnel.newFunnel.integratedWith')
                          }}
                        </span>
                        <span> Webhook </span>
                      </v-col>
                    </div>
                    <div v-if="integrationLength > 1">
                      <v-tooltip right content-class="right">
                        <template v-slot:activator="{ on, attrs }">
                          <v-hover open-delay="200">
                            <v-list-item v-bind="attrs" v-on="on" exact>
                              <v-col class="cta-action px-0" cols="12">
                                <span>
                                  {{
                                    $t(
                                      'message.pages.funnel.newFunnel.integratedWith'
                                    )
                                  }}
                                </span>
                                <div class="mx-2 mailchimp-container">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="114"
                                    height="32"
                                    viewBox="0 0 114 32"
                                    fill="none"
                                  >
                                    <path
                                      d="M47.2029 13.2007C46.1111 13.2007 45.5715 14.0595 45.3237 14.6138C45.1851 14.9235 45.1463 15.1681 45.034 15.1681C44.8754 15.1681 44.9888 14.9561 44.8597 14.4836C44.6896 13.8632 44.1762 13.2007 43.0854 13.2007C41.939 13.2007 41.4477 14.1697 41.2146 14.702C41.055 15.0663 41.055 15.1681 40.9333 15.1681C40.7558 15.1681 40.9028 14.8794 40.9826 14.5393C41.1401 13.8705 41.0204 13.3582 41.0204 13.3582H39.2031V20.1939H41.6839V16.7933C41.6839 16.1225 41.9642 15.271 42.445 15.271C43.0004 15.271 43.1117 15.6973 43.1117 16.4878V20.1949H45.603V16.7923C45.603 16.1949 45.8465 15.27 46.3683 15.27C46.9321 15.27 47.0318 15.8695 47.0318 16.4868V20.1928H49.4779V16.1729C49.4779 14.3902 48.8491 13.2007 47.2029 13.2007Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M89.3173 13.2007C88.2254 13.2007 87.6858 14.0595 87.438 14.6138C87.2995 14.9235 87.2606 15.1681 87.1483 15.1681C86.9898 15.1681 87.0958 14.8983 86.974 14.4836C86.7924 13.8663 86.3399 13.2007 85.1998 13.2007C84.0534 13.2007 83.562 14.1697 83.329 14.702C83.1694 15.0663 83.1694 15.1681 83.0476 15.1681C82.8702 15.1681 83.0172 14.8794 83.0969 14.5393C83.2544 13.8705 83.1347 13.3582 83.1347 13.3582H81.3164V20.1939H83.7972V16.7933C83.7972 16.1225 84.0775 15.271 84.5583 15.271C85.1137 15.271 85.225 15.6973 85.225 16.4878V20.1949H87.7163V16.7923C87.7163 16.1949 87.9598 15.27 88.4816 15.27C89.0454 15.27 89.1451 15.8695 89.1451 16.4868V20.1928H91.5912V16.1729C91.5923 14.3902 90.9634 13.2007 89.3173 13.2007Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M53.1113 18.5963C52.5181 18.7339 52.2105 18.5501 52.2105 18.1575C52.2105 17.6189 52.768 17.4026 53.5627 17.4026C53.9134 17.4026 54.243 17.4331 54.243 17.4331C54.243 17.664 53.7433 18.4514 53.1113 18.5963ZM53.716 13.2031C51.8158 13.2031 50.452 13.9023 50.452 13.9023V15.9559C50.452 15.9559 51.9586 15.0897 53.1795 15.0897C54.1548 15.0897 54.2745 15.6157 54.2304 16.0525C54.2304 16.0525 53.9491 15.9779 53.0913 15.9779C51.0693 15.9779 50.0479 16.8966 50.0479 18.3706C50.0479 19.769 51.1953 20.3528 52.1622 20.3528C53.5732 20.3528 54.1926 19.4047 54.3837 18.9554C54.516 18.6436 54.5401 18.4336 54.6588 18.4336C54.7942 18.4336 54.749 18.5848 54.7417 18.8945C54.7302 19.4383 54.7553 19.8488 54.8425 20.1953H56.7112V16.8315C56.7112 14.7317 55.9679 13.2031 53.716 13.2031Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M60.7969 20.1951H63.2777V11.2891H60.7969V20.1951Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M66.0088 16.7775C66.0088 16.1634 66.5799 15.6038 67.6276 15.6038C68.7699 15.6038 69.6885 16.1539 69.8942 16.2788V13.9009C69.8942 13.9009 69.1688 13.2017 67.3851 13.2017C65.5048 13.2017 63.9385 14.3019 63.9385 16.6704C63.9385 19.039 65.36 20.3523 67.3799 20.3523C68.9578 20.3523 69.8984 19.4851 69.8984 19.4851V17.2269C69.6013 17.3938 68.772 17.9691 67.6392 17.9691C66.4403 17.9702 66.0088 17.4179 66.0088 16.7775Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M74.9215 13.2029C73.4853 13.2029 72.9383 14.5646 72.8281 14.8008C72.7178 15.037 72.6633 15.1735 72.573 15.1704C72.4165 15.1651 72.5257 14.8806 72.5866 14.6958C72.7021 14.3473 72.9467 13.4328 72.9467 12.3084C72.9467 11.5462 72.8438 11.29 72.8438 11.29H70.7021V20.1951H73.1829V16.7945C73.1829 16.2402 73.4044 15.2722 74.0291 15.2722C74.5467 15.2722 74.7094 15.6554 74.7094 16.4281V20.1951H77.1902V16.5772C77.1912 14.8229 76.9004 13.2029 74.9215 13.2029Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M77.9971 13.3677V20.195H80.4778V13.3677C80.4778 13.3677 80.0611 13.6112 79.2401 13.6112C78.4191 13.6112 77.9971 13.3677 77.9971 13.3677Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M79.232 11.2197C78.3932 11.2197 77.7129 11.6638 77.7129 12.2108C77.7129 12.7578 78.3932 13.2019 79.232 13.2019C80.0708 13.2019 80.7511 12.7578 80.7511 12.2108C80.7501 11.6638 80.0708 11.2197 79.232 11.2197Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M57.5117 13.3677V20.195H59.9925V13.3677C59.9925 13.3677 59.5757 13.6112 58.7547 13.6112C57.9338 13.6112 57.5117 13.3677 57.5117 13.3677Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M58.7467 11.2197C57.9078 11.2197 57.2275 11.6638 57.2275 12.2108C57.2275 12.7578 57.9078 13.2019 58.7467 13.2019C59.5855 13.2019 60.2658 12.7578 60.2658 12.2108C60.2658 11.6638 59.5855 11.2197 58.7467 11.2197Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M95.8421 18.7262C95.2731 18.7262 94.8542 18.0049 94.8542 16.9991C94.8542 16.0227 95.2847 15.2721 95.8222 15.2721C96.513 15.2721 96.807 15.9052 96.807 16.9991C96.807 18.1372 96.5361 18.7262 95.8421 18.7262ZM96.5235 13.2007C95.2479 13.2007 94.6632 14.1571 94.4091 14.702C94.2411 15.0621 94.2495 15.1681 94.1267 15.1681C93.9493 15.1681 94.0963 14.8794 94.176 14.5393C94.3335 13.8705 94.2138 13.3582 94.2138 13.3582H92.3955V22.0816H94.8763V19.3162C95.1702 19.8138 95.7141 20.3461 96.5518 20.3461C98.346 20.3461 99.2489 18.828 99.2489 16.7766C99.251 14.4521 98.1696 13.2007 96.5235 13.2007Z"
                                      fill="#100F0D"
                                    />
                                    <path
                                      d="M30.4373 15.2659C30.6042 15.2459 30.7638 15.2449 30.9108 15.2659C30.9958 15.0706 31.0105 14.7347 30.9339 14.3693C30.8205 13.8255 30.6662 13.4958 30.3481 13.5473C30.03 13.5987 30.0184 13.9924 30.1318 14.5362C30.1969 14.8417 30.3103 15.1042 30.4373 15.2659Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M27.7071 15.6964C27.9349 15.7961 28.0746 15.8622 28.1292 15.8045C28.1649 15.7688 28.1544 15.6995 28.0998 15.6113C27.9874 15.4276 27.7565 15.2418 27.5119 15.1378C27.0111 14.9226 26.4137 14.994 25.9518 15.3247C25.7996 15.436 25.6557 15.5903 25.6757 15.6848C25.682 15.7153 25.7051 15.7384 25.7586 15.7457C25.8846 15.7604 26.3224 15.5378 26.8274 15.5074C27.1843 15.4853 27.4804 15.5966 27.7071 15.6964Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M27.2497 15.9579C26.9537 16.0051 26.7899 16.1028 26.6849 16.1931C26.5957 16.2708 26.54 16.3579 26.54 16.4188C26.54 16.4482 26.5526 16.4639 26.5631 16.4723C26.5768 16.4839 26.5925 16.4912 26.6114 16.4912C26.6786 16.4912 26.8277 16.4314 26.8277 16.4314C27.2403 16.2834 27.5122 16.3023 27.781 16.3327C27.93 16.3495 28.0004 16.359 28.0329 16.3075C28.0424 16.2928 28.0539 16.2613 28.0245 16.213C27.9573 16.0996 27.6581 15.9096 27.2497 15.9579Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M29.5144 16.9164C29.716 17.015 29.9365 16.9762 30.0089 16.8292C30.0813 16.6822 29.9764 16.4838 29.7748 16.3851C29.5732 16.2864 29.3528 16.3253 29.2803 16.4723C29.2089 16.6182 29.3129 16.8166 29.5144 16.9164Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M30.8093 15.7852C30.6455 15.782 30.5101 15.9616 30.5069 16.1862C30.5027 16.4109 30.6329 16.5946 30.7956 16.5967C30.9594 16.5999 31.0948 16.4204 31.098 16.1957C31.1022 15.9721 30.972 15.7883 30.8093 15.7852Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M19.8332 19.8266C19.7922 19.7751 19.7261 19.7909 19.661 19.8066C19.6159 19.8171 19.5644 19.8287 19.5088 19.8276C19.3891 19.8255 19.2873 19.7741 19.2295 19.6859C19.155 19.5714 19.1592 19.4014 19.2411 19.2061C19.2526 19.1798 19.2652 19.1504 19.2799 19.1189C19.4111 18.825 19.6306 18.3326 19.3838 17.8633C19.198 17.5105 18.8957 17.2901 18.5324 17.2439C18.1839 17.1998 17.8238 17.3289 17.5949 17.5819C17.2338 17.9809 17.1771 18.5237 17.2464 18.7158C17.2716 18.7861 17.3125 18.805 17.3409 18.8092C17.4028 18.8176 17.4931 18.7725 17.5498 18.6192C17.554 18.6087 17.5592 18.5909 17.5666 18.5699C17.5918 18.489 17.639 18.3378 17.7167 18.2171C17.8101 18.0712 17.955 17.9704 18.1261 17.9347C18.3004 17.8979 18.4778 17.9305 18.6269 18.0281C18.8799 18.194 18.9776 18.5037 18.8694 18.7998C18.8138 18.9531 18.7224 19.246 18.7424 19.4864C18.7833 19.9735 19.0825 20.1688 19.3513 20.1898C19.6127 20.1993 19.7954 20.0533 19.8416 19.9452C19.871 19.8822 19.8479 19.8434 19.8332 19.8266Z"
                                      fill="#231F20"
                                    />
                                    <path
                                      d="M22.3194 10.8823C23.1729 9.89651 24.2228 9.03877 25.1645 8.55793C25.197 8.54113 25.2317 8.57682 25.2138 8.60832C25.1393 8.74375 24.9955 9.03352 24.9493 9.25294C24.9419 9.28759 24.9797 9.31278 25.0081 9.29284C25.5939 8.89388 26.6122 8.46659 27.5046 8.41094C27.5434 8.40884 27.5613 8.45819 27.5308 8.48128C27.3954 8.58522 27.2463 8.7301 27.1382 8.87604C27.1193 8.90123 27.1371 8.93693 27.1676 8.93693C27.7943 8.94113 28.6794 9.16055 29.2557 9.48391C29.2946 9.50596 29.2673 9.58155 29.2232 9.57105C28.3508 9.37158 26.924 9.21935 25.4416 9.58155C24.1178 9.90491 23.1078 10.4026 22.3708 10.939C22.3341 10.9663 22.289 10.918 22.3194 10.8823ZM26.5692 20.4362C26.5692 20.4372 26.5702 20.4372 26.5702 20.4383C26.5692 20.4372 26.5692 20.4372 26.5692 20.4362ZM30.0882 20.8519C30.1134 20.8414 30.1313 20.812 30.1281 20.7837C30.125 20.748 30.0935 20.7228 30.0578 20.7259C30.0578 20.7259 28.2363 20.9958 26.5167 20.3658C26.7036 19.7569 27.2022 19.9763 27.955 20.0372C29.3124 20.1181 30.5292 19.9196 31.4278 19.6614C32.2068 19.4378 33.2304 18.9968 34.0252 18.37C34.2929 18.959 34.3884 19.6068 34.3884 19.6068C34.3884 19.6068 34.5963 19.57 34.7695 19.6761C34.9333 19.7769 35.054 19.9868 34.9711 20.5286C34.8041 21.5417 34.3737 22.3627 33.6504 23.1186C33.2105 23.5921 32.6751 24.0047 32.0641 24.3039C31.7314 24.4783 31.3848 24.6248 31.0279 24.7417C28.3004 25.632 25.5099 24.6535 24.6102 22.5506C24.5388 22.3921 24.4779 22.2273 24.4296 22.054C24.0464 20.6682 24.3719 19.0063 25.3891 17.9595V17.9585C25.4521 17.8923 25.5162 17.8136 25.5162 17.7149C25.5162 17.632 25.4637 17.5448 25.4185 17.4829C25.0626 16.9664 23.8291 16.0866 24.0768 14.3837C24.2543 13.1606 25.3241 12.2986 26.3214 12.3501C26.4054 12.3543 26.4904 12.3595 26.5744 12.3648C27.007 12.39 27.3839 12.4456 27.7397 12.4603C28.335 12.4865 28.8704 12.3994 29.5056 11.8713C29.7198 11.6928 29.8909 11.5385 30.1817 11.4892C30.2121 11.4839 30.2877 11.4566 30.4399 11.464C30.5943 11.4724 30.7423 11.5144 30.8746 11.6026C31.3827 11.9406 31.4551 12.7606 31.4814 13.36C31.4961 13.7023 31.5381 14.5307 31.5517 14.7679C31.5843 15.3118 31.7271 15.3884 32.0158 15.4829C32.1785 15.5364 32.3297 15.5763 32.5512 15.6383C33.2241 15.8272 33.6231 16.0194 33.875 16.265C34.0252 16.4194 34.0944 16.5821 34.1165 16.7385C34.1963 17.3181 33.6672 18.033 32.2667 18.6829C30.736 19.3937 28.8788 19.5732 27.5959 19.4304C27.4972 19.4199 27.1476 19.38 27.1466 19.38C26.1198 19.2414 25.5351 20.5685 26.1513 21.4766C26.5482 22.0624 27.6295 22.4435 28.7109 22.4435C31.1916 22.4435 33.0971 21.3842 33.8068 20.4698C33.8278 20.4425 33.8299 20.4393 33.8635 20.3889C33.8981 20.3364 33.8698 20.307 33.8257 20.3375C33.2462 20.7343 30.673 22.3081 27.9203 21.8346C27.9203 21.8346 27.5854 21.78 27.281 21.6614C27.0385 21.5669 26.5303 21.3338 26.4684 20.812C28.6888 21.5018 30.0882 20.8519 30.0882 20.8519ZM17.8859 15.5721C17.1132 15.7223 16.4319 16.1601 16.0161 16.7648C15.7673 16.5569 15.3033 16.1559 15.2214 15.9984C14.5569 14.7364 15.9469 12.2818 16.918 10.896C19.319 7.47131 23.0784 4.87917 24.818 5.34952C25.1015 5.42931 26.038 6.51592 26.038 6.51592C26.038 6.51592 24.2984 7.48076 22.6858 8.82669C20.5116 10.5002 18.8696 12.9327 17.8859 15.5721ZM19.1846 21.3653C19.068 21.3853 18.9484 21.3937 18.8276 21.3905C17.6655 21.359 16.4098 20.3123 16.2849 19.0713C16.1474 17.6992 16.8476 16.644 18.0885 16.3931C18.2366 16.3637 18.4161 16.3459 18.6093 16.3564C19.3043 16.3942 20.3289 16.9286 20.563 18.4435C20.7719 19.7842 20.4423 21.1501 19.1846 21.3653ZM34.9312 18.9359C34.9217 18.9002 34.8566 18.664 34.7674 18.3774C34.6782 18.0918 34.5858 17.8902 34.5858 17.8902C34.9438 17.3548 34.9501 16.8761 34.9018 16.6052C34.8514 16.2692 34.7107 15.9826 34.4293 15.6866C34.1469 15.3905 33.5706 15.0871 32.7601 14.8593C32.6677 14.833 32.3622 14.749 32.3349 14.7417C32.3328 14.7238 32.3129 13.739 32.294 13.3159C32.2803 13.0104 32.2541 12.5327 32.106 12.0624C31.9297 11.4262 31.6221 10.8697 31.2389 10.5128C32.2982 9.41462 32.9596 8.20517 32.9575 7.16789C32.9543 5.17209 30.504 4.56841 27.4846 5.81881C27.4815 5.81986 26.8495 6.08863 26.8453 6.09073C26.8421 6.08758 25.6884 4.95581 25.6716 4.94111C22.2281 1.93953 11.463 13.9049 14.9044 16.811L15.6561 17.4482C15.4608 17.9532 15.3841 18.5328 15.4471 19.1553C15.528 19.9553 15.9406 20.7217 16.6083 21.3139C17.2434 21.8766 18.078 22.2325 18.8875 22.2315C20.2271 25.3181 23.2874 27.211 26.8747 27.3181C30.7234 27.4325 33.9538 25.6268 35.3081 22.3826C35.3963 22.1548 35.7721 21.1291 35.7721 20.2231C35.7742 19.3128 35.2587 18.9359 34.9312 18.9359Z"
                                      fill="#231F20"
                                    />
                                  </svg>
                                </div>
                                <span>+{{ integrationLength - 1 }}</span>
                              </v-col>
                            </v-list-item>
                          </v-hover>
                        </template>
                        <div
                          style="display: grid"
                          v-for="index in integrationLength"
                          :key="index"
                        >
                          <span v-if="integrations[index - 1]"
                            >•
                            {{
                              formatIntegrationName(integrations[index - 1])
                            }}</span
                          >
                        </div>
                      </v-tooltip>
                    </div>
                  </div>
                  <div
                    v-for="(quizVideoId, qIndex) in item.quizAwnsersQuantity"
                    :key="`${item.id}-quiz-${qIndex}`"
                  >
                    <v-divider class="internal-divider"></v-divider>
                    <div
                      v-if="item.hasQuiz"
                      style="align-items: center; display: flex"
                      class="d-flex quiz-link-anchor"
                      ref="linkAnchor"
                      :class="`quiz-link-anchor-${qIndex}`"
                    >
                      <v-col class="d-flex cta-title" cols="5">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M14.1973 17.598C14.1973 16.4407 13.2588 15.5022 12.1015 15.5022C10.9441 15.5022 10.0056 16.4407 10.0056 17.598C10.0056 18.7554 10.9441 19.6938 12.1015 19.6938C13.2588 19.6938 14.1973 18.7554 14.1973 17.598ZM8.48193 6.16737C8.48193 5.00999 7.5435 4.07157 6.38612 4.07157C5.22874 4.07157 4.29032 5.00999 4.29032 6.16737C4.29032 7.32475 5.22874 8.26318 6.38612 8.26318C7.5435 8.26318 8.48193 7.32475 8.48193 6.16737ZM19.9126 6.16737C19.9126 5.00999 18.9742 4.07157 17.8168 4.07157C16.6594 4.07157 15.721 5.00999 15.721 6.16737C15.721 7.32475 16.6594 8.26318 17.8168 8.26318C18.9742 8.26318 19.9126 7.32475 19.9126 6.16737ZM21.4363 6.16737C21.4363 7.90501 20.2117 9.35502 18.5786 9.70504V10.9301C18.5786 11.3891 18.4228 11.8311 18.094 12.1599C17.7651 12.4888 17.3232 12.6446 16.8642 12.6446H12.8633V14.0594C14.4965 14.4094 15.721 15.8603 15.721 17.598C15.721 19.5971 14.1006 21.2176 12.1015 21.2176C10.1023 21.2176 8.48193 19.5971 8.48193 17.598C8.48193 15.8603 9.70639 14.4094 11.3396 14.0594V12.6446H7.33868C6.87974 12.6446 6.43776 12.4888 6.10892 12.1599C5.78007 11.8311 5.62427 11.3891 5.62427 10.9301V9.70504C3.99116 9.35502 2.7666 7.90501 2.7666 6.16737C2.7666 4.16826 4.38701 2.54785 6.38612 2.54785C8.38523 2.54785 10.0056 4.16826 10.0056 6.16737C10.0056 7.90501 8.78108 9.35502 7.14798 9.70504V10.9301C7.14798 11.0427 7.1825 11.0772 7.18705 11.0818C7.1916 11.0863 7.22608 11.1208 7.33868 11.1208H16.8642C16.9768 11.1208 17.0113 11.0863 17.0159 11.0818C17.0204 11.0772 17.0549 11.0427 17.0549 10.9301V9.70504C15.4218 9.35502 14.1973 7.90501 14.1973 6.16737C14.1973 4.16826 15.8177 2.54785 17.8168 2.54785C19.8159 2.54785 21.4363 4.16826 21.4363 6.16737Z"
                            :fill="!$vuetify.theme.dark ? '#636578' : '#B9BBC6'"
                          />
                        </svg>
                        {{ $t('message.quiz.alternative') }}
                        {{ qIndex + 1 }}
                      </v-col>
                      <v-col class="cta-action" cols="7">
                        <span v-if="!item.isLinkQuiz[qIndex]" class="pr-5">
                          {{ item.quizText[qIndex] }}
                        </span>
                        <span
                          v-else
                          class="link-field pr-5"
                          style="max-width: 185px"
                        >
                          <v-icon class="mr-1" size="12"> mdi-link </v-icon>
                          <span class="text-ellipsis">
                            {{ item.quizText[qIndex] }}
                          </span>
                        </span>
                      </v-col>
                      <div
                        style="top: -12px"
                        class="line-analytics"
                        v-if="
                          item.linkedToRight &&
                          isAnalyticsEnabled &&
                          !isOverlayVisible &&
                          item.hasQuiz &&
                          !item.isLinkQuiz[qIndex]
                        "
                      >
                        <div class="tooltip">
                          {{ item.viewsQuiz[qIndex] || 0 }}
                          {{ $t('message.pages.funnel.newFunnel.access') }} ({{
                            (item.analytics.totalViews === 0
                              ? 0
                              : (item.viewsQuiz[qIndex] /
                                  item.analytics.totalViews) *
                                100
                            ).toFixed(0)
                          }}%)
                          {{
                            $t('message.pages.funnel.newFunnel.nextInteraction')
                          }}
                        </div>
                        <div class="line-analytics-value">
                          <span> {{ item.viewsQuiz[qIndex] || 0 }} </span>
                        </div>
                        <div class="line-analytics-percent">
                          <span>
                            {{
                              (item.analytics.totalViews === 0
                                ? 0
                                : (item.viewsQuiz[qIndex] /
                                    item.analytics.totalViews) *
                                  100
                              ).toFixed(0)
                            }}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="index in item.buttonQuantity"
                    :key="`${item.id}-quiz-${index}`"
                  >
                    <v-divider class="internal-divider"></v-divider>
                    <div
                      v-if="item.hasButton"
                      style="align-items: center; display: flex"
                      class="d-flex button-link-anchor"
                      ref="buttonLinkAnchor"
                      :class="`button-link-anchor-${index}`"
                    >
                      <v-col class="d-flex align-center cta-title" cols="4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          style="margin-right: 2px"
                        >
                          <path
                            d="M12.0344 12.6811C11.9984 12.5906 11.9896 12.4916 12.0093 12.3962C12.0289 12.3009 12.076 12.2134 12.1449 12.1445C12.2137 12.0757 12.3012 12.0285 12.3966 12.0089C12.492 11.9893 12.591 11.998 12.6814 12.0341L21.6814 15.5341C21.7779 15.5718 21.8603 15.6385 21.9172 15.7251C21.9741 15.8116 22.0028 15.9137 21.9991 16.0173C21.9955 16.1208 21.9598 16.2206 21.897 16.303C21.8342 16.3854 21.7473 16.4462 21.6484 16.4771L18.2044 17.5451C18.049 17.5931 17.9077 17.6783 17.7927 17.7933C17.6777 17.9083 17.5925 18.0497 17.5444 18.2051L16.4774 21.6481C16.4466 21.7469 16.3857 21.8338 16.3034 21.8966C16.221 21.9595 16.1211 21.9951 16.0176 21.9988C15.9141 22.0024 15.812 21.9738 15.7254 21.9169C15.6389 21.8599 15.5721 21.7775 15.5344 21.6811L12.0344 12.6811Z"
                            :stroke="
                              !$vuetify.theme.dark ? '#636578' : '#B9BBC6'
                            "
                            stroke-width="1.6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21 11V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H11"
                            :stroke="
                              $vuetify.theme.dark ? '#636578' : '#636578'
                            "
                            stroke-width="1.6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ $t('message.pages.video.button') }}
                        {{ index }}
                      </v-col>
                      <v-col class="cta-action" cols="8">
                        <span class="mr-3" v-if="!item.isLinkButton[index - 1]">
                          {{
                            $t(
                              'message.pages.funnel.newFunnel.playAnotherVideo'
                            )
                          }}
                        </span>
                        <span
                          v-else
                          class="link-field mr-3"
                          style="max-width: 185px"
                        >
                          <v-icon class="mr-1" size="12"> mdi-link </v-icon>
                          <span class="text-ellipsis">
                            {{ item.buttonLink[index - 1] }}
                          </span>
                        </span>
                      </v-col>
                    </div>
                  </div>

                  <div>
                    <v-divider class="internal-divider"></v-divider>
                    <div class="my-4">
                      <span
                        @click="editVideo(item)"
                        class="addInteraction-text px-5"
                        >{{
                          $t('message.pages.funnel.newFunnel.newInteraction')
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-app>
      <v-dialog v-model="dialog" max-width="400" max-height="366">
        <v-card style="height: 366px; padding: 20px">
          <v-col cols="12"> </v-col>

          <v-card-actions class="modal-actions">
            <v-btn class="cancel-btn" text @click="closeDialog">
              <span> {{ $t('message.cancel') }} </span></v-btn
            >
            <v-btn
              class="remove-btn"
              color="#A81914"
              @click="removeVideo"
              :disabled="isDeleting"
            >
              <span v-if="isDeleting">
                <v-icon>mdi-loading mdi-spin</v-icon>
              </span>
              <span v-else>{{ $t('message.remove') }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <BaseModal
        hookSufix="FunnelDiscardChangesModal"
        modalWidth="400px"
        minHeight="372px"
        :noDefaultPadding="true"
        :smallToolbarPadding="true"
        :closeBtnAbsPos="true"
      >
        <template #content>
          <v-card flat class="pa-8">
            <v-col cols="12">
              <v-row no-gutters align="center" justify="center">
                <img src="" />
              </v-row>
            </v-col>

            <v-card-actions class="mt-5 modal-actions">
              <base-btn class="cancel-btn" text @click="noSave">
                <span>
                  {{ $t('message.pages.funnel.newFunnel.goWithoutSave') }}
                </span></base-btn
              >
              <base-btn class="remove-btn" @click="saveAndExit">
                <span>
                  {{ $t('message.pages.funnel.newFunnel.goAndSave') }}
                </span></base-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </BaseModal>

      <base-float-menu
        v-if="funnelVideosLength !== 0 || droppedItems.length !== 0"
      >
        <div style="display: flex; align-items: center">
          <template style="display: flex; align-items: center">
            <base-btn
              style="
                width: 40px;
                height: 40px;
                padding: 0px;
                margin-right: 16px;
              "
              :disabled="!oldDroppedItems.length || equalsOldDroppedItems"
              @click="backDroppedItems"
              type="neutral"
            >
              <v-icon size="20">panda-undo</v-icon>
            </base-btn>
            <base-btn
              style="width: 40px; height: 40px; padding: 0px"
              :disabled="!newDroppedItems.length || equalsNewDroppedItems"
              @click="forwardDroppedItems"
              type="neutral"
            >
              <v-icon size="20">panda-redo</v-icon>
            </base-btn>
            <div class="divider-vertical"></div>
            <base-btn
              style="
                width: 40px;
                height: 40px;
                padding: 0px;
                margin-right: 16px;
              "
              type="tertiary"
              @click="zoomOut"
              :style="
                disableZoomOut
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' }
              "
            >
              <v-icon
                size="20"
                :style="
                  disableZoomOut ? { color: '#b7c2d2' } : { color: '#7a8696' }
                "
                >mdi-magnify-minus-outline</v-icon
              >
            </base-btn>
            <base-btn
              style="width: 40px; height: 40px; padding: 0px"
              @click="zoomIn"
              type="tertiary"
              :style="
                disableZoomIn
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' }
              "
            >
              <v-icon
                size="20"
                :style="
                  disableZoomIn ? { color: '#b7c2d2' } : { color: '#7a8696' }
                "
                >mdi-magnify-plus-outline</v-icon
              >
            </base-btn>
            <div class="divider-vertical"></div>
            <base-btn @click="reset" class="px-2" type="neutral">
              <div style="display: flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  style="margin-right: 12px"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.5 3.25C11.5 2.83579 11.8358 2.5 12.25 2.5H16.75C17.1642 2.5 17.5 2.83579 17.5 3.25V7.75C17.5 8.16421 17.1642 8.5 16.75 8.5C16.3358 8.5 16 8.16421 16 7.75V4H12.25C11.8358 4 11.5 3.66421 11.5 3.25Z"
                    :fill="$vuetify.theme.dark ? '#C2C5D6' : '#3F404C'"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.25 11.5C3.66421 11.5 4 11.8358 4 12.25V16H7.75C8.16421 16 8.5 16.3358 8.5 16.75C8.5 17.1642 8.16421 17.5 7.75 17.5H3.25C2.83579 17.5 2.5 17.1642 2.5 16.75V12.25C2.5 11.8358 2.83579 11.5 3.25 11.5Z"
                    :fill="$vuetify.theme.dark ? '#C2C5D6' : '#3F404C'"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.2803 2.71967C17.5732 3.01256 17.5732 3.48744 17.2803 3.78033L12.0303 9.03033C11.7374 9.32322 11.2626 9.32322 10.9697 9.03033C10.6768 8.73744 10.6768 8.26256 10.9697 7.96967L16.2197 2.71967C16.5126 2.42678 16.9874 2.42678 17.2803 2.71967Z"
                    :fill="$vuetify.theme.dark ? '#C2C5D6' : '#3F404C'"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.03033 10.9697C9.32322 11.2626 9.32322 11.7374 9.03033 12.0303L3.78033 17.2803C3.48744 17.5732 3.01256 17.5732 2.71967 17.2803C2.42678 16.9874 2.42678 16.5126 2.71967 16.2197L7.96967 10.9697C8.26256 10.6768 8.73744 10.6768 9.03033 10.9697Z"
                    :fill="$vuetify.theme.dark ? '#C2C5D6' : '#3F404C'"
                  />
                </svg>
                <span style="padding-bottom: 2px">{{
                  $t('message.pages.funnel.newFunnel.fillScreen')
                }}</span>
              </div>
            </base-btn>
            <div class="divider-vertical"></div>
            <base-btn
              size="small"
              type="secondary"
              :loading="loadingSave"
              :disabled="loadingSave"
              @click="handleOpenAddVideo()"
            >
              {{ $t('message.pages.funnel.emptyStateEdit.addVideo') }}
            </base-btn>
          </template>
        </div>
      </base-float-menu>
      <add-video-funnel />
      <add-video-destiny-funnel :funnelFolderId="funnelFolderId" />
      <remove-video-funnel />
      <upload-list
        v-if="uploadFiles.length"
        :files="uploadFiles"
        :handleCancel="handleCancel"
        :percent="uploadProgress"
        :handlePause="handlePause"
        :paused="uploadPaused"
        :handleResume="handleResume"
      />
      <import-videos :uppyConfig="uppy" />
      <rename-funnel />
      <share-funnel />
      <remove-funnel />
      <preview-funnel />
    </template>
  </page-view>
  <div
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      justify-content: space-between;
    "
    v-else
  >
    <div></div>
    <div class="d-flex flex-column align-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          d="M56 13.333C55.9998 11.8604 54.8057 10.667 53.333 10.667H10.666C9.19351 10.6672 8.00018 11.8605 8 13.333V40C8 41.4727 9.19341 42.6668 10.666 42.667H53.333C54.8058 42.667 56 41.4728 56 40V13.333ZM61.333 40C61.333 44.4183 57.7513 48 53.333 48H34.666V53.333H42.666L42.9395 53.3467C44.2839 53.4834 45.333 54.6194 45.333 56C45.333 57.3806 44.2839 58.5166 42.9395 58.6533L42.666 58.667H21.333C19.8602 58.667 18.666 57.4728 18.666 56C18.666 54.5272 19.8602 53.333 21.333 53.333H29.333V48H10.666C6.24789 47.9998 2.66602 44.4182 2.66602 40V13.333C2.66619 8.91499 6.248 5.33318 10.666 5.33301H53.333C57.7512 5.33301 61.3328 8.91488 61.333 13.333V40Z"
          fill="url(#paint0_linear_6240_22720)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_6240_22720"
            x1="2.66602"
            y1="32"
            x2="61.333"
            y2="32"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3F55EE" />
            <stop offset="1" stop-color="#8594FF" />
          </linearGradient>
        </defs>
      </svg>
      <span class="body-bold-medium text-center">{{
        $t('message.pages.funnel.mobileEditor.title')
      }}</span>
      <span class="body-regular-small text-center mt-8">{{
        $t('message.pages.funnel.mobileEditor.description')
      }}</span>
      <span class="body-regular-small text-center mt-2"
        >{{ $t('message.pages.funnel.mobileEditor.knowMore')
        }}<a
          :href="$t('message.memberGetMember.faqModal.articleUrl')"
          target="_blank"
          rel="noopener"
          class="brand-60-base--text body-bold-small"
          style="text-decoration: none"
        >
          {{ $t('message.memberGetMember.faqModal.article') }}
          <v-icon size="14px" class="brand-60-base--text mb-1">
            mdi-open-in-new
          </v-icon>
        </a></span
      >
    </div>
    <base-btn
      style="width: 90%"
      class="mb-4 ma-2"
      @click="handleBackToListing"
      >{{ $t('message.pages.funnel.mobileEditor.button') }}</base-btn
    >
  </div>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import Portuguese from '@uppy/locales/lib/pt_BR'
import English from '@uppy/locales/lib/en_US'
import interact from 'interactjs'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'
// import analyticsApi from '@/services/newAnalyticsApi'
import EmbedVideo from '@/components/EmbedVideo.vue'
import { subDays } from 'date-fns'
import BaseModal from '@/components/BaseModal.vue'
import videosApi from '@/services/videosApi'
import foldersApi from '@/services/foldersApi'
import profileApi from '@/services/profileApi'
import integrationsApi from '@/services/integrationsApi'
import playerApi from '@/services/playerApi'
import BaseFloatMenu from '@/components/BaseFloatMenu.vue'
// API
import funnelApi from '@/services/funnelApi'
import RemoveVideoFunnel from '../Modals/RemoveVideoFunnel.vue'
import AddVideoFunnel from '../Modals/AddVideoFunnel.vue'
import AddVideoDestinyFunnel from '../Modals/AddVideoDestinyFunnel.vue'
import ImportVideos from '../AddVideoModais/ImportVideos.vue'
import UploadList from '../../Videos/NewVideo/UploadList.vue'
import Vimeo from '@/utils/Vimeo'
import Dashboard from '@uppy/dashboard'
import Uppy from '@uppy/core'
import tus from '@uppy/tus'
import GoogleDrive from '@uppy/google-drive'
//import Dropbox from '@uppy/dropbox'
import Onedrive from '@uppy/onedrive'
import Url from '@uppy/url'
import {
  UPLOADER_COMPANION_URL,
  BACKUP_UPLOADER_URL,
  ENV_CONFIG,
} from '@/config/envs'
import RenameFunnel from '../Modals/RenameFunnel.vue'
import ShareFunnel from '../Modals/ShareFunnel.vue'
import RemoveFunnel from '../Modals/RemoveFunnel.vue'
import PreviewFunnel from '../Modals/PreviewFunnel.vue'
export default {
  components: {
    pageView: () => import('@/layout/VideoPage/PageView_VideoPage.vue'),
    BaseHeader: () => import('@/layout/VideoPage/BaseHeader_VideoPage.vue'),
    BaseModal,
    EmbedVideo,
    BaseFloatMenu,
    RemoveVideoFunnel,
    AddVideoFunnel,
    UploadList,
    ImportVideos,
    AddVideoDestinyFunnel,
    RenameFunnel,
    RemoveFunnel,
    ShareFunnel,
    PreviewFunnel,
  },
  // beforeRouteLeave(to, from, next) {
  //   // if (this.hasSaved) {
  //   //   next()
  //   // } else {
  //   //   this.leaveDialog = true
  //   //   this.$root.$emit('openFunnelDiscardChangesModal', 'change')
  //   //   this.nextRoute = to
  //   //   this.next = next
  //   // }
  // },
  data() {
    return {
      loading: true,
      zoomInDisabled: false,
      zoomOutDisabled: false,
      intervalId: null,
      leaveDialog: false,
      showPlusIndex: null,
      uploadPaused: false,
      uploadProgress: 0,
      uploadOpened: false,
      loadingSave: false,
      droppedItemSelected: null,
      uploadFiles: [],
      toBeUploaded: [],
      isFetched: false,
      tusEndpoint: '',
      funnelFolderId: '',
      uppyUpdated: 0,
      currentY: 0,
      currentX: 0,
      playOpensFullscreen: false,
      playOpensFullscreenNative: false,
      nextRoute: null,
      isDeleting: false,
      videoCopyData: null,
      isCopied: false,
      next: null,
      hasSaved: true,
      showMenuEmbed: false,
      videosLimit: 5000,
      videoId: null,
      noData: true,
      showVideoDataModal: false,
      selectedVideo: '',
      zoomLevel: 1,
      startTime: '00:00',
      timeVideo: 0,
      embedSelected: 'general',
      menuPosition: {
        x: window.innerWidth / 2 - 300,
        y: 130,
      },
      isLoading: false,
      isExternalSourceVideo: false,
      searchVideoText: '',
      filteredItems: [],
      selectedItems: [],
      videoConfig: null,
      disableZoomIn: false,
      disableZoomOut: false,
      funnelVideosLength: null,
      isAnalyticsEnabled: false,
      allVideos: [],
      dateRange: [],
      profile: {
        vsl: {
          restartAfterEnd: false,
        },
      },
      video: {},
      watchingPreview: false,
      integrations: null,
      funnel: {},
      integrationLength: 0,
      isMenuClosed: true,
      blockedWheel: false,
      totalViewsSum: 0,
      totalViewsUntilEndSum: 0,
      isItemBeingMoved: false,
      droppedItems: [],
      isDragging: false,
      dialog: false,
      funnelName: 'Nome do Funil',
      headers: [
        {
          prop: '_action',
          name: 'action',
          actionName: 'select',
          width: 1,
          alignItems: 'center',
          justifyContent: 'start',
        },
        {
          prop: '_action',
          name: 'title',
          actionName: 'titleCommon',
          alignItems: 'center',
          justifyContent: 'start',
        },
        {
          prop: '_action',
          name: 'goInto',
          actionName: 'search',
          width: 10,
          alignItems: 'center',
          justifyContent: 'start',
        },
      ],
      metrics: [
        {
          title: this.$t(
            'message.pages.funnel.analyticsFunnel.metricsTitleVisualize'
          ),
          icon: 'mdi-arrow-up',
          percentage: '0%',
          value: 0,
          data: '0',
        },
        {
          title: this.$t(
            'message.pages.funnel.analyticsFunnel.metricsTitleUntilEnd'
          ),
          icon: 'mdi-arrow-up',
          percentage: '0%',
          value: 0,
          data: '0',
        },
      ],
      lastFolder: {
        name: '',
        id: null,
        parent_folder_id: null,
      },
      selectedFolder: null,
      showDuplicateModal: false,
      selectedItem: null,
      isOverlayVisible: false,
      isPreviewOverlayVisible: false,
      breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
      selectedContent: 1,
      videoSrc: '',
      firstVideoId: null,
      linkingItem: null, // Item currently selected for linking
      lines: [],
      firstVideo: null,
      oldDroppedItems: [],
      newDroppedItems: [],
    }
  },
  props: {},
  watch: {
    droppedItems: {
      allVideos: {
        handler() {
          this.filteredItems = this.allItems
        },
        immediate: true,
        deep: true,
      },
      handler(newVal) {
        if (newVal.length > 0) {
          let firstVideo = newVal.find((video) => video.is_first === true)
          if (!firstVideo) {
            firstVideo = newVal[0]
          }
          this.firstVideo = firstVideo
          this.videoSrc = firstVideo.video_player
          this.firstVideoId = firstVideo.id
          this.videoId = this.firstVideoId
          this.video = firstVideo
        } else {
          this.videoSrc = ''
          this.firstVideoId = ''
          this.firstVideo = null
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    ...mapState('user', {
      profile: 'profile',
      planInfo: 'userPlanInfo',
      mainVideos: 'mainVideos',
      folders: 'mainFolders',
      subFolderVideos: 'subFolderVideos',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    equalsOldDroppedItems() {
      return this.oldDroppedItems == this.droppedItems
    },
    equalsNewDroppedItems() {
      return this.newDroppedItems == this.droppedItems
    },
    uppy() {
      this.uppyUpdated
      const objTus = this.handleTusObject()
      if (!this.isChrome() || this.isMobile()) {
        objTus.resume = false
        objTus.parallelUploads = 1
      }
      let objCompanion = this.handleCompanionObj()
      const instanceUppy = new Uppy({
        autoProceed: true,
        allowMultipleUploads: false,
        restrictions: {
          allowedFileTypes: ['video/*', '.ts'],
        },
        locale: this.uppyLocale,
      })
        .use(tus, objTus)
        .use(Dashboard)
        .use(Vimeo, { ...objCompanion, id: 'Vimeo' })
        .use(Url, { ...objCompanion, id: 'url' })
        .use(GoogleDrive, { ...objCompanion, id: 'google-drive' })
        //.use(Dropbox, { ...objCompanion, id: 'dropbox' }) // temporarily disabling Dropbox integration... waiting for the project to update Uppy and Companion to the latest versions
        .use(Onedrive, { ...objCompanion, id: 'onedrive' })
      return instanceUppy
    },
    truncatedVideoName() {
      const name = this.selectedVideo.name || 'N/A'
      return name.length > 10 ? `${name.substring(0, 10)}...` : name
    },
    zoomStyle() {
      return {
        transform: `scale(${this.zoomLevel})`,
        transformOrigin: 'top left',
        width: `${100 / this.zoomLevel}%`,
        height: `${100 / this.zoomLevel}%`,
      }
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 40
    },
    allItems() {
      const validFolders = this.toBeSelectedFolders.filter(
        (item) => item.status !== 'DELETING'
      )
      const validVideos = this.allVideos.filter(
        (item) => item.status !== 'DELETING'
      )

      return validFolders.concat(validVideos)
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      return selectedFolders
    },
  },
  created() {
    this.dateRange = [subDays(new Date(), 7), new Date()]

    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.getVideos()
    this.$root.$on('toggle-analytics', (isExpanded) => {
      this.isAnalyticsEnabled = isExpanded
      if (this.isAnalyticsEnabled) {
        this.lines.forEach((line) => {
          line.line.setOptions({ startSocketGravity: 80, color: '#7a8696' })
        })
      }
      if (!this.isAnalyticsEnabled) {
        this.lines.forEach((line) => {
          line.line.setOptions({ startSocketGravity: 0 })
        })
      }
    })
  },
  async mounted() {
    this.loading = true
    await this.loadLeaderLine()
    await this.getFunnelVideos()
    window.addEventListener('wheel', this.handleWheel)
    document.documentElement.classList.add('no-overflow')
    document.documentElement.classList.add('funnel-wrap-display')
    window.addEventListener('keydown', this.handleKeydownEvent)
    this.$root.$on('activeWheel', () => {
      this.blockedWheel = false
    })
    await this.pageRequests()
    this.setUppyLanguage(this.getLocale())
    this.startInterval()
    await this.getIntegrations()
    this.updateZIndex()
    this.$root.$on('removeVideoFunnel', async () => {
      await this.removeVideo()
    })
    this.$root.$on('manual-drop', (selectedItem) => {
      this.handleManualDrop(selectedItem)
    })
    this.$root.$on('rename-funnel', (name) => {
      this.funnelName = name
    })
    await this.createLinksByRedirectId()
    await this.createButtonLinks()
    await this.createQuizLinks()
    this.loading = false
    this.$nextTick(() => {
      if (this.droppedItems.length) {
        this.initializeInteract()
        this.updateLinesPosition()
        this.waitForElementsAndActivateDrag()
        this.findAndFocusItem()
        this.updateZIndex()
      }
    })
  },
  beforeMount() {},
  beforeDestroy() {
    this.$root.$off('rename-funnel')
    this.$root.$off('manual-drop')
    this.$root.$off('removeVideoFunnel')
    clearInterval(this.intervalId)
    this.removeAllLines()
    window.removeEventListener('wheel', this.handleWheel)
    document.documentElement.classList.remove('no-overflow')
    document.documentElement.classList.remove('funnel-wrap-display')
  },
  methods: {
    ...mapActions('video', [
      'updateVideoRedirect',
      'updateOnFunnel',
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_FIRST_ACCESS',
      'UPDATE_ROUTED_VIDEO',
      'UPDATE_MAIN_VIDEOS',
      'UPDATE_MAIN_FOLDERS',
      'UPDATE_ALL_FOLDERS',
      'UPDATE_SUB_FOLDER_VIDEOS',
      'UPDATE_SUB_FOLDER',
      'UPDATE_DID_FETCH_VIDEOS',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
      'UPDATE_DELETED_FOLDERS',
    ]),
    removeWheel() {
      this.blockedWheel = true
    },
    backDroppedItems() {
      if (!this.oldDroppedItems.length) return
      this.$set(this, 'droppedItems', this.oldDroppedItems)
      this.updateZIndex()
      this.$nextTick(() => {
        this.updateLinesPosition()
      })
    },
    forwardDroppedItems() {
      if (!this.newDroppedItems.length) return
      this.$set(this, 'droppedItems', this.newDroppedItems)
      this.updateZIndex()
      this.$nextTick(() => {
        this.updateLinesPosition()
      })
    },
    async getIntegrations() {
      try {
        let ret = await integrationsApi.getIntegrations()
        this.integrations = ret.data.map((integration) => integration.service)
        this.integrationLength = this.integrations.length
      } catch (e) {
        console.log('e', e)
      }
    },
    handleStatusAnalytics() {
      this.isAnalyticsEnabled = !this.isAnalyticsEnabled
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    isChrome() {
      return !!window.chrome
    },
    handleTusObject() {
      let uploaderUrl = `${BACKUP_UPLOADER_URL}/files/`
      if (ENV_CONFIG !== 'production') {
        uploaderUrl = `${BACKUP_UPLOADER_URL}:8443/files/`
      }
      const storageUrl = Storage.getItem('uploaderUrlv3')
      if (storageUrl) {
        uploaderUrl = `${storageUrl}/files/`
        if (ENV_CONFIG !== 'production') {
          uploaderUrl = `${storageUrl}:8443/files/`
        }
      }
      let objTus = {
        id: 'tus',
        endpoint: uploaderUrl,
        resume: false,
        retryDelays: [0, 1000],
        parallelUploads: 1,
        limit: 1,
      }
      if (!this.isChrome() || this.isMobile()) {
        objTus.resume = false
        objTus.parallelUploads = 1
      }
      return objTus
    },
    handleCompanionObj() {
      let companionUrl = `${UPLOADER_COMPANION_URL}:3020`
      if (ENV_CONFIG !== 'production') {
        companionUrl = `${UPLOADER_COMPANION_URL}:3021`
      }
      let objCompanion = {
        id: 'companion',
        target: Dashboard,
        companionUrl: companionUrl,
      }
      return objCompanion
    },
    handlePause() {
      this.uploadPaused = true
      this.uppy.pauseAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleResume() {
      this.uploadPaused = false
      this.uppy.resumeAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleCancel() {
      this.uppy.cancelAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleOpenAddVideoDestiny() {
      this.removeWheel()
      this.$root.$emit('openAddVideoDestinyFunnel', this.funnelFolderId)
    },
    handleOpenAddVideo() {
      this.removeWheel()
      this.$root.$emit('openAddVideo')
    },
    cacheData() {
      const funnelId = this.$route.params.id
      const droppedItems = this.droppedItems
      const expirationTime = Date.now() + 6 * 60 * 60 * 1000

      const funnelData = {
        id: funnelId,
        items: droppedItems,
        zoomLevel: this.zoomLevel,
        expiration: expirationTime,
      }
      localStorage.setItem(`funnel_${funnelId}`, JSON.stringify(funnelData))
    },
    handleWheel(event) {
      if (this.blockedWheel) return
      const contentBox = document.querySelector('.content-box')
      if (contentBox) {
        return
      }
      const container = document.querySelector('.dragable-area')
      if (!container) return
      const deltaY = event.deltaY * -1
      let maxY = 2500
      let minY = -10000
      this.currentY = Math.max(Math.min(this.currentY + deltaY, maxY), minY)

      container.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
      this.$nextTick(() => {
        this.updateLinesPosition()
      })
    },
    async pageRequests() {
      if (!window.db) {
        this.$root.$emit('initDexie')
      }

      await this.readUserFolders()
      await this.getAllAccountVideos()
      this.UPDATE_DID_FETCH_VIDEOS(true)
      this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(false)
      this.handleBackTo({ name: '', id: null, parent_folder_id: null })
    },
    checkDraftOrConverting() {
      return this.allItems.some(
        (item) => item.status === 'DRAFT' || item.status === 'CONVERTING'
      )
    },
    startInterval() {
      if (!this.intervalId) {
        this.intervalId = setInterval(async () => {
          if (this.checkDraftOrConverting()) {
            await this.pageRequests()
          } else {
            clearInterval(this.intervalId)
            this.intervalId = null
          }
        }, 10000)
      }
    },
    waitForElementsAndActivateDrag(retries = 100) {
      this.$nextTick(() => {
        const wrapper = document.querySelector('.zoom-container')
        const container = document.querySelector('.dragable-area')
        if (wrapper && container) {
          if (this.droppedItems.length) {
            this.activeDrag()
            this.initializeInteract()
          }
        } else if (retries > 0) {
          setTimeout(() => {
            this.waitForElementsAndActivateDrag(retries - 1)
          }, 100)
        }
      })
    },
    activeDrag() {
      const wrapper = document.querySelector('.zoom-container')
      const container = document.querySelector('.dragable-area')
      let isDragging = false
      let startX, startY

      wrapper.addEventListener('mousedown', (e) => {
        if (!this.isItemBeingMoved) {
          isDragging = true
          startX = e.clientX - this.currentX
          startY = e.clientY - this.currentY
          wrapper.style.cursor = 'grabbing'
          this.$nextTick(() => {
            this.updateLinesPosition()
          })
        }
      })

      wrapper.addEventListener('mouseleave', () => {
        isDragging = false
        wrapper.style.cursor = 'grab'
        this.isItemBeingMoved = false
        this.$nextTick(() => {
          this.updateLinesPosition()
        })
      })

      wrapper.addEventListener('mouseup', () => {
        isDragging = false
        wrapper.style.cursor = 'grab'
        this.isItemBeingMoved = false
        this.$nextTick(() => {
          this.updateLinesPosition()
        })
      })

      wrapper.addEventListener('mousemove', (e) => {
        if (
          !isDragging ||
          this.isItemBeingMoved ||
          this.droppedItems.length === 0 ||
          this.watchingPreview
        ) {
          return
        }
        e.preventDefault()
        const x = Math.max(Math.min(e.clientX - startX, 2500), -10000)
        const y = Math.max(Math.min(e.clientY - startY, 2500), -10000)
        this.currentX = x
        this.currentY = y
        container.style.transform = `translate(${x}px, ${y}px)`
        this.$nextTick(() => {
          this.updateLinesPosition()
        })
      })
    },
    async readUserFolders() {
      try {
        let ret = await foldersApi.getUserFolders()
        let notDeletedFolders = ret.data.folders.filter(
          (folder) => folder.status != false
        )
        let deletedFolders = ret.data.folders.filter(
          (folder) => folder.status === false
        )
        this.UPDATE_MAIN_FOLDERS(notDeletedFolders)
        this.UPDATE_DELETED_FOLDERS(deletedFolders)
        this.UPDATE_ALL_FOLDERS(ret.data.folders)
      } catch (e) {
        console.log(e)
      }
    },
    async getAllAccountVideos() {
      try {
        const videos = await this.loopVideos()
        let filteredFoldersIds = []
        let videosResponse = videos
        for (let folderId in videosResponse) {
          filteredFoldersIds.push(folderId)
        }
        await window.db.videos.clear()
        for (let folderId of filteredFoldersIds) {
          let arrToBeAdded = videos[folderId].map((obj) => ({
            ...obj,
            folder_id: folderId,
          }))
          await window.db.videos.bulkPut(arrToBeAdded)
        }
        this.allVideos = await window.db.videos.toArray()
      } catch (error) {
        this.isFetching = false
      }
    },

    async videosRequest() {
      let queryObject = {
        limit: this.videosLimit,
      }
      try {
        const ret = await videosApi.getAllVideosAndBin(queryObject)
        return ret
      } catch (error) {
        console.log(error)
      }
    },

    async loopVideos() {
      let videosObject = {}
      try {
        const allVideosCount = await window.db.videos.count()
        if (allVideosCount <= 0 || allVideosCount < 10000) {
          await window.db.videos.clear()
          return await this.getVideosAndUpdateDB()
        } else {
          const allVideos = await window.db.videos.toArray()
          allVideos.forEach((video) => {
            if (video.folder_id) {
              const key = video.folder_id || 'root'
              if (!videosObject[key]) {
                videosObject[key] = [video]
              } else {
                videosObject[key].push(video)
              }
            }
          })
        }
        return videosObject
      } catch (err) {
        this.formatErr(err)
      }
    },
    async getVideosAndUpdateDB() {
      const videos = await this.getVideosFromApi()
      let filteredFoldersIds = []
      let videosResponse = videos
      for (let folderId in videosResponse) {
        filteredFoldersIds.push(folderId)
      }
      for (let folderId of filteredFoldersIds) {
        let arrToBeAdded = videos[folderId].map((obj) => ({
          ...obj,
          folder_id: folderId,
        }))
        await window.db.videos.bulkPut(arrToBeAdded)
      }
      this.lastUpdatedVideos = await this.formatNowDate()
      localStorage.setItem('lastUpdatedVideos', this.lastUpdatedVideos)
      return videos
    },
    async getVideosFromApi() {
      try {
        let videosObject = {}
        let shouldFetchAgain = true
        let page = 0
        while (shouldFetchAgain) {
          let ret = null
          if (page > 0) {
            ret = await this.videosRequest(page)
          } else {
            ret = await this.videosRequest()
          }
          if (page === 0) {
            videosObject = ret.data.videos
          } else {
            for (let folder in ret.data.videos) {
              if (videosObject[folder]) {
                videosObject[folder].push(...ret.data.videos[folder])
              } else {
                videosObject[folder] = ret.data.videos[folder]
              }
            }
          }
          page++
          if (ret.data.total < this.videosLimit) {
            shouldFetchAgain = false
          }
        }
        return videosObject
      } catch (err) {
        this.formatErr(err)
      }
    },
    isLinkedFrom(item) {
      return this.lines.some(
        (line) =>
          line.start === this.$refs.droppedItem[this.droppedItems.indexOf(item)]
      )
    },

    async loadRedirectVideos() {
      const redirectPromises = this.droppedItems.map(async (item) => {
        if (item.hasEndRedirect && item.redirectEndVideoId) {
          try {
            const isDuplicate = this.droppedItems.some(
              (droppedItem) => droppedItem.id === item.redirectEndVideoId
            )

            if (isDuplicate) {
              return
            }

            const videoInfo = await videosApi.getAVideo(item.redirectEndVideoId)
            let previousItemX = item.x
            let previousItemY = item.y
            const videoData = videoInfo.data

            const newItem = {
              id: videoData.id,
              status: videoData.status,
              x: previousItemX + 600,
              y: previousItemY,
              video_external_id: videoData.video_external_id,
              name: videoData.title,
              preview: videoData.preview,
              length: videoData.length,
              highlighted: false,
              is_first: false,
              redirectEndVideoId: null,
            }
            this.droppedItems.push(newItem)
            await this.$nextTick()
            await this.createLink(item, newItem)
            let sources = newItem.connectedSource || []
            sources.push({
              id: item.id,
              type: 'end',
            })
            this.$set(newItem, 'connectedSource', sources)
          } catch (error) {
            console.error('Error loading redirect video:', error)
          }
        }
      })

      await Promise.all(redirectPromises)
    },

    async loadQuizRedirectVideos() {
      const redirectPromises = this.droppedItems.map(async (item) => {
        if (item.hasQuiz && item.quizVideoId && item.quizVideoId.length > 0) {
          try {
            for (let i = 0; i < item.quizVideoId.length; i++) {
              const quizVideoId = item.quizVideoId[i]

              const isDuplicate = this.droppedItems.some(
                (droppedItem) => droppedItem.id === quizVideoId
              )

              if (isDuplicate) {
                continue
              }
              const videoInfo = await videosApi.getAVideo(quizVideoId)
              let previousItemX = item.x
              let previousItemY = item.y + 240 * i
              const videoData = videoInfo.data

              const newItem = {
                id: videoData.id,
                status: videoData.status,
                x: previousItemX + 600,
                y: previousItemY + 240,
                video_external_id: videoData.video_external_id,
                name: videoData.title,
                preview: videoData.preview,
                length: videoData.length,
                highlighted: false,
                is_first: false,
                redirectEndVideoId: null,
              }

              this.droppedItems.push(newItem)
              await this.$nextTick()
              await this.createLink(
                item,
                newItem,
                `quiz-link-anchor-${i}`,
                'preview-anchor'
              )
              let sources = newItem.connectedSource || []
              sources.push({
                id: item.id,
                type: 'quiz',
              })
              this.$set(newItem, 'connectedSource', sources)
            }
          } catch (error) {
            console.error('Error loading quiz redirect video:', error)
          }
        }
      })

      await Promise.all(redirectPromises)
    },

    async loadButtonRedirectVideos() {
      const redirectPromises = this.droppedItems.map(async (item) => {
        if (
          item.hasButton &&
          item.buttonVideoId &&
          item.buttonVideoId.length > 0
        ) {
          try {
            for (let i = 0; i < item.buttonVideoId.length; i++) {
              if (item.isLinkButton[i]) {
                continue
              }
              const buttonVideoId = item.buttonVideoId[i]

              const isDuplicate = this.droppedItems.some(
                (droppedItem) => droppedItem.id === buttonVideoId
              )

              if (isDuplicate) {
                continue
              }
              if (!buttonVideoId) {
                continue
              }
              const videoInfo = await videosApi.getAVideo(buttonVideoId)
              let previousItemX = item.x
              let previousItemY = item.y
              const videoData = videoInfo.data
              const newItem = {
                id: videoData.id,
                status: videoData.status,
                x: previousItemX,
                y: previousItemY + 400,
                video_external_id: videoData.video_external_id,
                name: videoData.title,
                preview: videoData.preview,
                length: videoData.length,
                highlighted: false,
                is_first: false,
                redirectEndVideoId: null,
              }

              this.droppedItems.push(newItem)
              await this.$nextTick()
              await this.createLink(
                item,
                newItem,
                `button-link-anchor-${i + 1}`,
                'preview-anchor'
              )
              let sources = newItem.connectedSource || []
              sources.push({
                id: item.id,
                type: 'button',
              })
              this.$set(newItem, 'connectedSource', sources)
            }
          } catch (error) {
            console.error('Error loading button redirect video:', error)
          }
        }
      })

      await Promise.all(redirectPromises)
    },
    hasHistory() {
      return window.history.length > 2
    },
    handleBackToListing() {
      // if (this.hasHistory()) {
      //   this.$router.go(-1)
      //   return
      // }
      if (this.loadingSave) return
      this.$router.push({ name: 'Funnel' }).catch(() => {})
    },
    initializeInteractForItem(item) {
      const el = this.$refs.droppedItem[this.droppedItems.indexOf(item)]
      if (el) {
        interact(el).draggable({
          listeners: {
            start: (event) => {
              this.isItemBeingMoved = true
              event.target.classList.add('dragged-item')
            },
            move: (event) => {
              const target = event.target
              const x =
                (parseFloat(target.getAttribute('data-x')) || 0) +
                event.dx / this.zoomLevel
              const y =
                (parseFloat(target.getAttribute('data-y')) || 0) +
                event.dy / this.zoomLevel
              target.style.transform = `translate(${x}px, ${y}px)`
              target.setAttribute('data-x', x)
              target.setAttribute('data-y', y)

              this.lines.forEach((item) => {
                if (item.start === target || item.end === target) {
                  item.line.position()
                }
              })
            },
            end: (event) => {
              this.isItemBeingMoved = false
              event.target.classList.remove('dragged-item')

              const target = event.target
              const x = parseFloat(target.getAttribute('data-x')) || 0
              const y = parseFloat(target.getAttribute('data-y')) || 0
              this.hasSaved = false
              const itemIndex = this.$refs.droppedItem.indexOf(target)
              if (itemIndex !== -1) {
                this.oldDroppedItems = JSON.parse(
                  JSON.stringify(this.droppedItems)
                )

                const updatedItems = JSON.parse(
                  JSON.stringify(this.droppedItems)
                )
                updatedItems[itemIndex].x += x
                updatedItems[itemIndex].y += y

                // Salva o novo estado
                this.newDroppedItems = updatedItems

                // Atualiza o droppedItems com os novos valores
                this.$set(this, 'droppedItems', updatedItems)
              }

              target.style.transform = ''
              target.setAttribute('data-x', 0)
              target.setAttribute('data-y', 0)
            },
          },
        })
      }
    },
    closeMenuWithDelay() {
      setTimeout(() => {
        this.handleCloseMenu()
        this.isMenuClosed = true
      }, 300)
    },
    closeMenuWithoutDelay() {
      this.handleCloseMenu()
      this.isMenuClosed = true
    },
    handlePlayOpensFullscreen({ script, native }) {
      this.playOpensFullscreen = script
      this.playOpensFullscreenNative = native
    },
    isVideoAddedToFunnel(video) {
      return this.droppedItems.some((item) => item.id === video.id)
    },

    confirmLeave() {
      this.leaveDialog = false
      this.next()
    },
    cancelLeave() {
      this.leaveDialog = false
      this.nextRoute = null
      this.next = null
    },
    getViewDifference(item) {
      const linkedItem = this.getLinkedItem(item)
      if (linkedItem) {
        return linkedItem.analytics.totalViews
      }
      return 0
    },
    getPercentageDifference(item) {
      const linkedItem = this.getLinkedItem(item)
      if (linkedItem) {
        const difference =
          item.analytics.totalViews - linkedItem.analytics.totalViews
        if (difference === 0) {
          return 0
        }
        const percentage = (linkedItem.analytics.totalViews / difference) * 100
        return percentage.toFixed(2)
      }
      return 0
    },

    getLinkedItem(item) {
      const linkedLine = this.lines.find(
        (line) =>
          line.start === this.$refs.droppedItem[this.droppedItems.indexOf(item)]
      )
      if (linkedLine) {
        const linkedItem =
          this.droppedItems[this.$refs.droppedItem.indexOf(linkedLine.end)]
        return linkedItem
      }
      return null
    },

    updateZIndex() {
      this.$nextTick(() => {
        const leaderLines = document.querySelectorAll('.leader-line')
        leaderLines.forEach((line) => {
          line.style.zIndex = '0'
        })
      })
    },

    updateLinesPosition() {
      this.lines.forEach((line) => {
        line.line.position()
      })
    },
    confirmRemoveVideo(item) {
      this.deselectItem()
      item.menu = false
      this.selectedVideo = item
      this.$root.$emit('openRemoveVideoFunnel', { group: this.selectedVideo })
    },
    closeDialog() {
      this.dialog = false
      this.selectedVideo = {}
    },
    async removeVideo() {
      this.isDeleting = true
      const funnelId = this.$route.params.id
      const videoId = this.selectedVideo.id
      this.hasSaved = false
      await this.saveFunnel()
      if (this.selectedVideo.connectedSource) {
        for (let connectedSourceItem of this.selectedVideo.connectedSource) {
          if (connectedSourceItem.type === 'end') {
            let initialVideo = this.droppedItems.find(
              (item) => item.id === connectedSourceItem.id
            )
            if (initialVideo) {
              initialVideo.redirectEndVideoId = ''
            }
            await this.updateVideoRedirect([initialVideo.id, null])
          }
          if (connectedSourceItem.type === 'button') {
            let initialVideo = this.droppedItems.find(
              (item) => item.id === connectedSourceItem.id
            )
            let matchedCta = initialVideo.buttonCta.find(
              (cta) => cta.metadata.videoId === this.selectedVideo.id
            )
            playerApi.deleteCta(initialVideo.id, matchedCta.id)
            if (initialVideo.buttonVideoId) {
              initialVideo.buttonVideoId = initialVideo.buttonVideoId.filter(
                (videoId) => videoId !== this.selectedVideo.id
              )
            }
          }

          if (connectedSourceItem.type === 'quiz') {
            let initialVideo = this.droppedItems.find(
              (item) => item.id === connectedSourceItem.id
            )
            let questions = initialVideo.videoQuestions.metadata.questions
            questions.forEach((question) => {
              question.answers = question.answers.filter((answer) => {
                return answer.redirectVideoId !== videoId
              })
            })

            if (initialVideo.quizVideoId) {
              initialVideo.quizVideoId = initialVideo.quizVideoId.filter(
                (quizId) => quizId !== this.selectedVideo.id
              )
            }

            const ctaData = {
              script: initialVideo.videoQuestions.script,
              type: 'video',
              time: initialVideo.videoQuestions.time,
              duration: initialVideo.videoQuestions.duration,
              metadata: {
                generalData: initialVideo.videoQuestions.metadata.generalData,
                selectedButtonPlacement:
                  initialVideo.videoQuestions.metadata.selectedButtonPlacement,
                disposition: initialVideo.videoQuestions.metadata.disposition,
                questions: initialVideo.videoQuestions.metadata.questions,
                ctaType: 'quiz',
                startTime: initialVideo.videoQuestions.metadata.startTime,
                endTime: initialVideo.videoQuestions.metadata.endTime,
                redirects: initialVideo.videoQuestions.metadata.redirects,
                videoRedirectExternalIds:
                  initialVideo.videoQuestions.metadata.videoRedirectExternalIds,
              },
              maxZIndex: true,
              pauseVideo: initialVideo.videoQuestions.pauseVideo,
              allowSkip: initialVideo.videoQuestions.allowSkip,
              id: initialVideo.videoQuestions.id,
            }
            playerApi.addCta(initialVideo.id, ctaData)
          }
        }
      }
      try {
        await funnelApi.removeVideosFromFunnel(funnelId, [videoId])
        const videoRemove = { video_id: videoId }
        await videosApi.deleteMultipleVideos([videoRemove])
        this.updateOnFunnel([videoId, false])
      } catch (error) {
        console.error('Error removing video from funnel:', error)
      } finally {
        const index = this.droppedItems.findIndex((item) => item.id === videoId)

        if (index !== -1) {
          this.removeLines(this.droppedItems[index])
          const removedItem = this.droppedItems.splice(index, 1)[0]

          const localStorageKey = `funnel_${funnelId}`
          const savedData = JSON.parse(localStorage.getItem(localStorageKey))
          if (savedData && savedData.items) {
            savedData.items = savedData.items.filter(
              (item) => item.id !== videoId
            )
            localStorage.setItem(localStorageKey, JSON.stringify(savedData))
          }

          if (removedItem.is_first && this.droppedItems.length > 0) {
            this.droppedItems[0].is_first = true
          }
          this.cacheData()
        }
      }
      this.handleSnackbar(
        this.$i18next.t('message.pages.AssistentIntern.successRemovedVideo')
      )
      this.closeDialog()
      this.removeAllLines()
      this.loading = true
      await this.pageRequests()
      this.startInterval()
      this.updateZIndex()
      this.getFunnelVideos()
      this.initializeInteract()
      await this.loadLeaderLine()
      this.isDeleting = false
      this.loading = false
      this.$nextTick(() => {
        if (this.droppedItems.length) this.waitForElementsAndActivateDrag()
      })
    },
    removeLines(item) {
      this.lines = this.lines.filter((line) => {
        const isRelatedLine =
          line.start ===
            this.$refs.droppedItem[this.droppedItems.indexOf(item)] ||
          line.end === this.$refs.droppedItem[this.droppedItems.indexOf(item)]

        if (isRelatedLine) {
          line.line.remove()
        }

        return !isRelatedLine
      })
    },
    applyCustomPosition(item, isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          const menu = this.$refs.menu
          if (menu && menu.$el) {
            menu.$el.style.transform += 'translate(34px, 60px)'
          }
        })
      }
    },
    removeAllLines() {
      this.lines.forEach((item) => item.line.remove())
      this.lines = []
    },

    loadLeaderLine() {
      const script = document.createElement('script')
      script.src =
        'https://cdnjs.cloudflare.com/ajax/libs/leader-line/1.0.7/leader-line.min.js'
      script.onload = () => {
        this.LeaderLine = window.LeaderLine
      }
      document.head.appendChild(script)
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = Math.floor(seconds % 60)

      const formattedHours = String(hours).padStart(2, '0')
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    async getAllItems(folders) {
      let items = []
      for (let item of folders) {
        if (item.name) {
          let vids = await window.db.videos
            .where({ folder_id: item.id })
            .toArray()
          items = items.concat(vids)
          let children = this.folders.filter(
            (folder) => folder.parent_folder_id === item.id
          )
          if (children.length) {
            await this.getAllItems(children)
          }
        }
      }
      return items
    },
    async handleBackTo(backToFolder) {
      this.startInterval()
      if (backToFolder.id) {
        this.allVideos = await window.db.videos
          .where({ folder_id: backToFolder.id })
          .toArray()
      } else {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        this.getVideos()
      }

      this.selectedFolder = null
      this.lastFolder = backToFolder

      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      ) {
        return
      }

      const index = this.breadcrumbArray.findIndex(
        (folder) => folder.id === backToFolder.id
      )
      this.breadcrumbArray = this.breadcrumbArray.slice(0, index + 1)
      this.filteredItems = this.allItems
    },
    getPreview(item) {
      return Array(this.allVideos || []).find((video) => item.id == video.id)
        .preview
    },
    async getVideos() {
      this.allVideos = await window.db.videos
        .where({ folder_id: 'root' })
        .toArray()
      this.filteredItems = this.allItems
    },
    async getFunnelVideos() {
      try {
        const { data } = await funnelApi.getFunnel(this.$route.params.id)
        this.funnelVideosLength = data.data.videos.length
        this.funnelName = data.data.name
        this.funnel = data.data
        if (data.data.videos.length > 0) {
          this.funnelFolderId = data.data.videos[0]?.folder_id
          await this.loadFunnelVideos(data.data.videos)
          await this.loadRedirectVideos()
          await this.loadQuizRedirectVideos()
          await this.loadButtonRedirectVideos()
        }
        this.updateLinesPosition()
      } catch (error) {
        console.error('Error loading funnel videos:', error)
      }

      this.$nextTick(() => {
        this.initializeInteract()
        this.updateLinesPosition()
      })
    },
    async loadFunnelVideos(videos) {
      const funnelId = this.$route.params.id
      const localStorageKey = `funnel_${funnelId}`

      const savedData = localStorage.getItem(localStorageKey)
      if (savedData) {
        const parsedData = JSON.parse(savedData)

        if (parsedData.expiration && Date.now() > parsedData.expiration) {
          localStorage.removeItem(localStorageKey)
        }
      }

      try {
        this.droppedItems = videos.map((video) => ({
          id: video.id,
          status: video.status,
          video_external_id: video.video_external_id,
          name: video.name,
          preview: video.preview,
          length: video.metadata.length,
          x: video.front_coordinates.x,
          y: video.front_coordinates.y,
          video_player: video.video_player,
          highlighted: false,
          is_first: video.is_first,
          redirectEndVideoId: null,
          analytics: { ...video.analytics },
        }))
        const chunkSize = 20
        const delay = 1000

        for (let i = 0; i < this.droppedItems.length; i += chunkSize) {
          const chunk = this.droppedItems.slice(i, i + chunkSize)
          const loadVideoDataPromises = chunk.map((item, index) =>
            this.loadVideoData(item.id, i + index)
          )

          await Promise.all(loadVideoDataPromises)
          if (i + chunkSize < this.droppedItems.length) {
            await new Promise((resolve) => setTimeout(resolve, delay))
          }
        }

        await this.createLinksByRedirectId()
        await this.createButtonLinks()
        await this.createQuizLinks()

        this.$nextTick(async () => {
          this.initializeInteract()
          this.recalculateTotalViews()
          this.recalculateViewsUntilEnd()
          this.updateLinesPosition()
        })
      } catch (error) {
        console.error('Error loading funnel videos:', error)
      }
    },
    async handleDeleteGroup() {
      const countVideos = this.funnel.videos?.length || 0
      this.$root.$emit('openRemoveFunnel', {
        group: this.funnel,
        countVideos,
      })
    },
    createButtonLinks() {
      this.droppedItems.forEach((item) => {
        if (item.buttonVideoId && item.buttonVideoId.length > 0) {
          item.buttonVideoId.forEach((buttonVideoId, index) => {
            if (buttonVideoId) {
              const targetItem = this.droppedItems.find(
                (video) => video.id === buttonVideoId
              )
              if (targetItem) {
                let sources = targetItem.connectedSource || []
                sources.push({
                  id: item.id,
                  type: 'button',
                })
                this.$set(targetItem, 'connectedSource', sources)
                this.createLink(
                  item,
                  targetItem,
                  `button-link-anchor-${index + 1}`,
                  'preview-anchor'
                )
              }
            }
          })
        }
      })
    },

    createQuizLinks() {
      this.droppedItems.forEach((item) => {
        if (item.quizVideoId && item.quizVideoId.length > 0) {
          item.quizVideoId.forEach((quizVideoId, index) => {
            if (quizVideoId) {
              const targetItem = this.droppedItems.find(
                (video) => video.id === quizVideoId
              )
              if (targetItem) {
                let sources = targetItem.connectedSource || []
                sources.push({
                  id: item.id,
                  type: 'quiz',
                })
                this.$set(targetItem, 'connectedSource', sources)
                this.createLink(
                  item,
                  targetItem,
                  `quiz-link-anchor-${index}`,
                  'preview-anchor'
                )
              }
            }
          })
        }
      })
    },
    // async getAVideoInfo() {
    //   let allSuccess = true
    //   const videoPromises = this.droppedItems.map(async (item) => {
    //     const videoFound = this.allVideos.find(
    //       (row) => row.video_external_id === item.video_external_id
    //     )
    //     if (videoFound) {
    //       try {
    //         const videoInfo = await videosApi.getAVideo(videoFound.id)
    //         if (videoInfo.data.config) {
    //           this.$set(item, 'config', videoInfo.data.config)
    //           const ctas = videoInfo.data.config.ctas
    //           if (ctas) {
    //             const buttonQuantity = ctas.filter(
    //               (row) => row.metadata.ctaType === 'button'
    //             )
    //             this.$set(item, 'buttonQuantity', buttonQuantity)
    //             let isLinkButton = []
    //             ctas.forEach((row) => {
    //               if (row.metadata.ctaType === 'button') {
    //                 this.$set(item, 'hasButton', true)
    //                 if (!item.buttonVideoId && row.metadata.redirectVideoId) {
    //                   this.$set(item, 'buttonVideoId', [
    //                     row.metadata.redirectVideoId,
    //                   ])
    //                 }
    //               }
    //             })
    //             this.$set(item, 'isLinkButton', isLinkButton)
    //           }
    //         }
    //         if (videoInfo.data.config.profile) {
    //           this.$set(item, 'videoProfileId', videoInfo.data.config.profile)
    //         } else {
    //           try {
    //             const ret = await this.createProfile(videoInfo.data.id)
    //             videoInfo.data.config.profile = ret.data.id
    //             this.$set(item, 'videoProfileId', videoInfo.data.config.profile)
    //             await this.setProfileToVideos([ret.data.id, videoInfo.data.id])
    //           } catch (profileErr) {
    //             console.error(
    //               `Erro ao criar profile para o vídeo ${videoInfo.data.id}:`,
    //               profileErr
    //             )
    //             allSuccess = false
    //           }
    //         }
    //         return videoInfo
    //       } catch (error) {
    //         console.error(
    //           `Erro ao buscar informações do vídeo ${videoFound.id}:`,
    //           error
    //         )
    //         allSuccess = false
    //         return null
    //       }
    //     } else {
    //       console.warn(
    //         `Vídeo não encontrado em allVideos para o external_id: ${item.video_external_id}`
    //       )
    //       allSuccess = false
    //       return null
    //     }
    //   })
    //   try {
    //     await Promise.all(videoPromises)
    //   } catch (err) {
    //     console.error('Erro inesperado ao processar vídeos:', err)
    //     allSuccess = false
    //   }
    //   return allSuccess
    // },

    checkboxSelection(item) {
      let alreadySelected = this.selectedItems.some(
        (searchedVideo) => searchedVideo.id === item.id
      )
      if (alreadySelected) {
        this.selectedItems = this.selectedItems.filter(
          (lookVideo) => lookVideo.id !== item.id
        )
      } else {
        this.selectedItems.push(item)
      }
    },
    async handleFilterSelected() {
      let videos = []
      let folders = []
      for (let item of this.selectedItems) {
        if (item.name) {
          folders.push(item)
        } else {
          videos.push(item)
        }
      }
      this.filteredVideos = [...videos]
      let result = await this.getAllItems(folders)
      this.filteredVideos = this.filteredVideos.concat(result)
      this.$root.$emit('filterSelected', this.filteredVideos)
      this.filteredVideos = []
    },
    async filterByExternalID() {
      if (!this.video_external_id) return

      const option = { video_external_id: this.video_external_id }

      const [videoInDB] = await window.db.videos.where(option).toArray()
      const videoInRoot = _.find(this.allVideos, option)

      let video

      if (videoInRoot) video = videoInRoot
      else {
        this.allVideos.push(videoInDB)
        video = videoInDB
      }

      this.selectedItems = [video]

      this.handleFilterSelected()
    },
    toggleWatchingPreview() {
      this.watchingPreview = !this.watchingPreview
      if (this.watchingPreview) {
        document.body.classList.add('hide-leader-lines')
      } else {
        document.body.classList.remove('hide-leader-lines')
      }
      this.$root.$emit(
        'preview-overlay-visibility-changed',
        this.watchingPreview
      )
    },

    showEmbed() {
      this.showMenuEmbed = true
      this.$root.$emit('embed-overlay-visibility-changed', this.showMenuEmbed)
    },

    handleDragStart(item, event) {
      if (!item.title) {
        event.preventDefault()
        return
      }
      this.isDragging = true
      event.dataTransfer.setData('item', JSON.stringify(item))
      event.dataTransfer.effectAllowed = 'move'
      event.target.classList.add('dragged-item')
      this.closeMenuWithDelay()
    },
    handleDragOver(event) {
      this.isDragging = true
      event.preventDefault()
    },
    handleDragLeave() {
      this.isDragging = false
    },
    async handleDrop(event) {
      this.isDragging = false
      this.selectedContent = ''
      const item = JSON.parse(event.dataTransfer.getData('item'))
      const rect = event.target.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top
      this.hasSaved = false

      const isDuplicate = this.droppedItems.some(
        (droppedItem) => droppedItem.id === item.id
      )
      if (isDuplicate) {
        this.showDuplicateModal = true
        return
      }

      this.selectedVideo = item
      let hasData = await this.checkIfHasData(this.selectedVideo)
      if (hasData) {
        this.showVideoDataModal = true
      } else {
        const isFirst = this.droppedItems.length === 0
        this.droppedItems.push({
          ...item,
          x,
          y,
          config: null,
          is_first: isFirst,
          connectedSource: [],
        })
        this.$nextTick(() => {
          this.initializeInteract()
          this.linkItem()
          this.activeDrag()
        })
        event.target.classList.remove('dragged-item')
        event.preventDefault()
        this.selectedContent = 1
        this.isMenuClosed = true
        this.cacheData()
      }
    },
    async handleManualDrop(selectedItem, isUpload) {
      let x = Math.floor(Math.random() * 400) + 100
      let y = Math.floor(Math.random() * 300) + 100
      if (this.droppedItems.length) {
        let maxIndex = 0
        let lastItemOrLinking = this.linkingItem
        if (!this.linkingItem) {
          for (let i = 1; i < this.droppedItems.length; i++) {
            if (this.droppedItems[i].x > this.droppedItems[maxIndex].x) {
              maxIndex = i
            }
          }
          lastItemOrLinking = this.droppedItems[maxIndex]
        }
        x = lastItemOrLinking.x + 500
        y = lastItemOrLinking.y
      }
      this.isDragging = false
      this.selectedContent = ''
      const item = selectedItem
      this.hasSaved = false

      const droppedItemSelected = this.droppedItems.find(
        (droppedItem) => droppedItem.id === item.id
      )
      // if (isDuplicate) {
      //   this.showDuplicateModal = true
      //   return
      // }

      this.selectedVideo = item
      this.droppedItemSelected = droppedItemSelected
      const isFirst = this.droppedItems.length === 0
      if (!droppedItemSelected)
        this.droppedItems.push({
          ...item,
          x,
          y,
          config: null,
          is_first: isFirst,
          connectedSource: [],
        })
      this.loadVideoData(item.id, this.droppedItems.length - 1)
      this.$nextTick(async () => {
        await this.initializeInteract()
        if (this.linkingItem) await this.linkSelectItem()

        await this.activeDrag()
      })
      await this.createLinksByRedirectId()
      this.selectedContent = 1
      if (!isUpload) await this.saveFunnel()
      else {
        const maxAttempts = 5
        let attempt = 0
        const retrySaveFunnel = async () => {
          try {
            this.loadingSave = true
            await this.saveFunnel(true)
          } catch (error) {
            attempt++
            if (attempt < maxAttempts) {
              const delay = Math.min(1000 * 2 ** attempt, 10000)
              setTimeout(retrySaveFunnel, delay)
            } else {
              this.loadingSave = false
              console.log(
                'Falha ao salvar o funil após várias tentativas:',
                error
              )
            }
          } finally {
            this.loadingSave = false
          }
        }
        retrySaveFunnel()
      }
    },
    handleCloseMenu() {
      this.$root.$emit('menu-change', 1)
      this.selectedContent = 1
    },
    handleOpenMenu() {
      this.$root.$emit('menu-change', 0)
      this.selectedContent = 0
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleEmbedEmit(embed) {
      this.handleSnackbar(this.$t('message.embedCopiedLink'))
      this.handleShowLink(embed)
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },

    async checkIfHasData(item) {
      const videoInfo = await videosApi.getAVideo(item.id)
      let hasEndRedirectData = false
      let hasButtonRedirectData = false
      let hasQuizRedirectData = false

      if (videoInfo.data.config.videoRedirect?.videoId) {
        hasEndRedirectData = true
      }

      if (videoInfo.data.config.ctas) {
        videoInfo.data.config.ctas.forEach((cta) => {
          if (cta.metadata.ctaType === 'button') {
            if (cta.metadata.redirectVideoId) {
              hasButtonRedirectData = true
            }
          }

          if (cta.metadata.ctaType === 'quiz') {
            cta.metadata.questions.forEach((question) => {
              question.answers.forEach((answer) => {
                if (
                  answer.action === 'redirect_video' &&
                  answer.redirectVideoId
                ) {
                  hasQuizRedirectData = true
                }
              })
            })
          }
        })
      }

      return hasEndRedirectData || hasButtonRedirectData || hasQuizRedirectData
        ? true
        : false
    },

    editVideo(item) {
      this.saveFunnel()

      this.$router.push({
        name: 'VideoPage',
        params: {
          id: item.id,
          funnel_id: this.funnel.id,
        },
      })
    },

    async handleDuplicate(videoToBeAdded) {
      try {
        const { data: clonedVideo } = await videosApi.cloneVideo(
          videoToBeAdded.id
        )
        const data = await videosApi.getAVideo(clonedVideo.id)
        this.videoCopyData = data.data
      } catch (e) {
        console.error(e)
      }
    },

    handleUseVideoWithData() {
      try {
        this.showVideoDataModal = false
        const { selectedVideo } = this
        const rect = event.target.getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top
        this.droppedItems.push({ ...selectedVideo, x, y, config: null })

        this.$nextTick(() => {
          this.initializeInteract()
          this.linkItem()
        })
        this.handleCloseMenu()
        this.isMenuClosed = true
      } catch (error) {
        console.error('Error setting video analytics data:', error)
      }
    },

    async handleCreateNewCopy() {
      this.loading = true
      this.showVideoDataModal = false
      const { selectedVideo } = this

      await this.handleDuplicate(selectedVideo)
      // const rect = event.target.getBoundingClientRect()
      const x = 10
      const y = 10

      this.droppedItems.push({
        ...this.videoCopyData,
        x,
        y,
      })

      this.$nextTick(() => {
        this.initializeInteract()
        this.linkItem()
      })

      this.handleCloseMenu()
      this.isMenuClosed = true
      this.loading = false
    },

    async handleImportModal() {
      this.handleCloseMenu()
      if (
        this.planLimit &&
        this.planInfo.subscription.status !== 'trialing' &&
        !this.planInfo.limit.trusted_charge_pos
      ) {
        this.$root.$emit('usageLimitModal', {
          open: true,
          storagePlan: this.planInfo?.limit?.traffic_plan,
          type: 'traffic',
        })
        return
      } else if (
        this.planLimit &&
        this.planInfo.subscription.status === 'trialing'
      ) {
        this.$root.$emit('ModalResetBillingCycle')
        return
      }
      this.$root.$emit('importModal', { open: true })
      this.keySelect.isAnyOtherModal = true
    },
    linkItem() {
      const lastItem = this.droppedItems[this.droppedItems.length - 1]
      this.$set(
        this.droppedItems[this.droppedItems.length - 1],
        'redirectEndVideoId',
        lastItem.id
      )
      this.createLink(this.linkingItem, lastItem)
      this.handleUpdateVideoRedirect()
      this.linkingItem = null
    },
    async linkSelectItem() {
      const lastItem = this.droppedItems.findIndex(
        (row) => row.id == this.linkingItem.id
      )
      this.$set(this.droppedItems[lastItem], 'redirectEndVideoId', lastItem.id)
      this.createLink(this.linkingItem, lastItem)
      await this.handleUpdateVideoRedirect()
      await this.createLinksByRedirectId()
      this.linkingItem = null
    },
    // initLink(item, index) {
    //   const nextItem = this.droppedItems[index + 1]
    //   if (index == this.droppedItems.length || !nextItem) return
    //   this.$set(nextItem, 'redirectEndVideoId', nextItem.id)
    //   this.createLink(item, nextItem)
    //   this.linkingItem = item
    //   console.log(item)
    //   this.handleUpdateVideoRedirect()
    // },
    async loadVideoData(videoId, index) {
      let videoInfoSuccess = false
      let videoInfoAttempts = 0
      const maxVideoInfoAttempts = 5
      let videoInfo

      while (!videoInfoSuccess && videoInfoAttempts < maxVideoInfoAttempts) {
        try {
          videoInfo = await videosApi.getAVideo(videoId)
          videoInfoSuccess = true
        } catch (error) {
          videoInfoAttempts++
          if (error.response && error.response.status === 404) {
            break
          }
          const delay = Math.min(1000 * 2 ** videoInfoAttempts, 30000)
          await new Promise((resolve) => setTimeout(resolve, delay))
        }
      }
      let videoProfileId = videoInfo.data?.config?.profile
      if (!videoProfileId) {
        try {
          const ret = await this.createProfile(videoInfo.data.id)
          videoInfo.data.config.profile = ret.data.id
          this.$set(videoInfo, 'videoProfileId', videoInfo.data.config.profile)
          await this.setProfileToVideos([ret.data.id, videoInfo.data.id])
          videoProfileId = ret.data.id
        } catch (err) {
          console.log(err)
        }
      }
      const videoPreview = videoInfo.data.preview
      const onFunnel = videoInfo.data.config?.onFunnel ?? false
      const videoPlayer = videoInfo.data.video_player

      let hasEndRestart = false

      let quizRedirects = null
      let buttonRedirects = null
      let endRedirectRedirects = null

      let hasQuiz = false
      let videoQuestions = []
      let viewsQuiz = []
      let hasButton = false
      let hasForm = false

      let viewsButton = []

      let buttonLink = []
      let buttonVideoId = []
      let isLinkButton = []
      let buttonCta = []
      let buttonQuantity = 0

      let quizVideoId = []
      let quizCtaId = []
      let isLinkQuiz = []
      let quizText = []
      let quizAwnsersQuantity = 0

      let hasEndRedirect = false

      try {
        if (videoProfileId) {
          let success = false
          let attempts = 0
          const profileMaxAttempts = 5
          let data

          while (!success && attempts < profileMaxAttempts) {
            try {
              const response = await profileApi.getProfileId(videoProfileId)
              data = response.data
              success = true
            } catch (error) {
              attempts++
              if (error.response && error.response.status === 404) {
                break
              }
              const delay = Math.min(1000 * 2 ** attempts, 30000)
              await new Promise((resolve) => setTimeout(resolve, delay))
            }
          }
          let hasVslConfig = data.vsl

          if (hasVslConfig === null) {
            let vsl = this.$store.state.video.profile.vsl ?? {}
            vsl.restartAfterEnd = false
            await this.updateProfile([
              videoProfileId,
              {
                vsl: vsl,
              },
            ])
            let success = false
            let data
            let attempts = 0
            const profileMaxAttempts = 5

            while (!success && attempts < profileMaxAttempts) {
              try {
                const response = await profileApi.getProfileId(videoProfileId)
                data = response.data
                success = true
              } catch (error) {
                attempts++
                await new Promise((resolve) => setTimeout(resolve, 1000))
              }
            }
            hasEndRestart = data.vsl.restartAfterEnd
          } else {
            hasEndRestart = data.vsl.restartAfterEnd
          }
        }

        if (videoInfo?.data?.config?.videoRedirect?.videoId) {
          hasEndRedirect = true
          this.$set(
            this.droppedItems[index],
            'redirectEndVideoId',
            videoInfo.data.config.videoRedirect.videoId
          )
        }

        if (videoInfo.data.config.ctas) {
          videoInfo.data.config.ctas.forEach((cta) => {
            if (cta.metadata.ctaType === 'quiz') {
              quizRedirects = cta.metadata.redirects
              hasQuiz = true
              videoQuestions = cta
              quizCtaId.push(cta.metadata.generalData.id)

              cta.metadata.questions.forEach((question) => {
                question.answers.forEach((answer) => {
                  if (
                    answer.action === 'redirect_video' &&
                    answer.redirectVideoId
                  ) {
                    quizVideoId.push(answer.redirectVideoId)
                    quizText.push(answer.text)
                    quizAwnsersQuantity++
                    isLinkQuiz.push(false)
                  } else if (answer.action === 'open_link') {
                    quizAwnsersQuantity++
                    isLinkQuiz.push(true)
                    quizText.push(answer.link)
                  } else {
                    quizText.push(answer.text)
                    quizAwnsersQuantity++
                    isLinkQuiz.push(false)
                  }
                })
              })

              // cta.metadata.questions.forEach((question) => {
              //   question.answers.forEach((answer) => {
              //     if (answer.action === 'open_link') {
              //       quizAwnsersQuantity++
              //       isLinkQuiz.push(true)
              //       quizText.push(answer.link)
              //     }
              //   })
              // })
            }

            if (cta.metadata.ctaType === 'button') {
              buttonLink.push(cta.metadata.link)
              buttonVideoId.push(cta.metadata.videoId)
              buttonCta.push(cta)
              buttonQuantity++
              if (cta.metadata.redirectVideoId) {
                isLinkButton.push(false)
              } else {
                isLinkButton.push(true)
              }
              hasButton = true
            }

            if (cta.metadata.ctaType === 'form') {
              hasForm = true
            }

            if (cta.metadata.ctaType === 'end_redirect') {
              endRedirectRedirects = cta.metadata.redirects
              hasEndRedirect = true
            }
          })
        }
        this.$set(this.droppedItems, index, {
          ...this.droppedItems[index],
          video_player: videoPlayer,
          preview: videoPreview,
          videoProfileId: videoProfileId,
          quizRedirects: quizRedirects,
          buttonRedirects: buttonRedirects,
          endRedirectRedirects: endRedirectRedirects,
          hasQuiz: hasQuiz,
          videoQuestions: videoQuestions,
          quizText: quizText,
          viewsQuiz: viewsQuiz,
          viewsButton: viewsButton,
          hasEndRestart: hasEndRestart,
          hasForm: hasForm,
          hasButton: hasButton,
          buttonLink: buttonLink,
          buttonQuantity: buttonQuantity,
          isLinkButton: isLinkButton,
          isLinkQuiz: isLinkQuiz,
          buttonVideoId: buttonVideoId,
          quizVideoId: quizVideoId,
          quizAwnsersQuantity: quizAwnsersQuantity,
          hasEndRedirect: hasEndRedirect,
          quizCtaId: quizCtaId,
          buttonCta: buttonCta,
          onFunnel: onFunnel,
        })

        this.cacheData()
      } catch (error) {
        console.error('Error fetching video analytics data:', error)
      }
    },
    handleShare() {
      this.removeWheel()
      this.$root.$emit('openShareFunnel', this.funnel)
    },
    handlePreview() {
      this.$root.$emit('openPreviewFunnel', this.funnel)
    },
    handleEditGroup() {
      this.$root.$emit('openRenameFunnel', this.funnel)
    },
    async handleUpdateVideoRedirect() {
      try {
        let linkingItem = this.linkingItem
        const lastItem =
          this.droppedItemSelected ||
          this.droppedItems[this.droppedItems.length - 1]
        let videoProfileId = linkingItem.config?.profile
        if (!videoProfileId) {
          try {
            const ret = await this.createProfile(linkingItem.id)
            if (!linkingItem.config) linkingItem.config = {}
            linkingItem.config.profile = ret.data.id
            this.$set(linkingItem, 'videoProfileId', linkingItem.config.profile)
            await this.setProfileToVideos([ret.data.id, linkingItem.id])
            videoProfileId = ret.data.id
          } catch (err) {
            console.log(err)
          }
        }
        this.profile.vsl.restartAfterEnd = false
        await this.updateProfile([
          linkingItem.videoProfileId,
          {
            vsl: this.profile.vsl,
          },
        ])
        await this.updateVideoRedirect([
          linkingItem.id,
          {
            videoId: lastItem.id,
            externalId: lastItem.video_external_id,
            title: lastItem.title,
          },
        ])

        let sources = lastItem.connectedSource || []
        sources.push({
          id: linkingItem.id,
          type: 'end',
        })
        this.$set(lastItem, 'connectedSource', sources)

        const linkingItemIndex = this.droppedItems.findIndex(
          (item) => item.id === linkingItem.id
        )
        this.$set(this.droppedItems, linkingItemIndex, {
          ...this.droppedItems[linkingItemIndex],
          redirectEndVideoId: lastItem.id,
          hasEndRedirect: true,
          nameVideoLinked: lastItem.title || lastItem.name,
        })
        // this.cacheData()
      } catch (error) {
        console.error('Error updating video redirect:', error)
      }
    },
    recalculateTotalViews() {
      this.totalViewsSum = this.droppedItems.reduce((sum, item) => {
        return sum + (item.analytics ? item.analytics.totalViews : 0)
      }, 0)
    },

    createLinksByRedirectId() {
      this.droppedItems.forEach((item) => {
        if (item.redirectEndVideoId && item.hasEndRedirect) {
          const targetItem = this.droppedItems.find(
            (video) => video.id === item.redirectEndVideoId
          )
          if (targetItem) {
            let sources = targetItem.connectedSource || []
            sources.push({
              id: item.id,
              type: 'end',
            })
            this.$set(targetItem, 'connectedSource', sources)
            item.nameVideoLinked = targetItem.name || targetItem.title
            this.createLink(item, targetItem)
          }
        }
      })
    },

    noSave() {
      this.hasSaved = true
      this.$router.push({ name: 'Funnel' })
    },

    saveAndExit() {
      this.saveFunnel()
      this.hasSaved = true
      this.$router.push({ name: 'Funnel' })
    },

    handleToggleSaveFunnel() {
      this.hasSaved = true
    },

    recalculateViewsUntilEnd() {
      this.totalViewsUntilEndSum = this.droppedItems.reduce((sum, item) => {
        return sum + (item.lastValue ? item.lastValue : 0)
      }, 0)
    },

    selectItem(index) {
      this.selectedItem = index
      this.isOverlayVisible = true
      this.$root.$emit('overlay-visibility-changed', this.isOverlayVisible)
      this.highlightLinkedItems(index)
    },
    async saveFunnel(retry) {
      if (this.droppedItems.length === 0) {
        return
      }
      if (!retry) this.loadingSave = true
      const firstItem = this.droppedItems.find((item) => item.is_first)
      if (!firstItem && this.droppedItems.length > 0) {
        this.droppedItems[0].is_first = true
      }
      const funnelId = this.$route.params.id
      const videos = this.droppedItems.map((item) => ({
        id: item.id,
        front_coordinates: {
          x: item.x,
          y: item.y,
        },
        is_first: item.is_first || false,
      }))
      this.hasSaved = true
      try {
        await funnelApi.addVideosToFunnel(funnelId, videos)
        await this.pageRequests()
        this.$nextTick(() => {
          this.handleSnackbar()
        })
        this.loadingSave = false
      } catch (error) {
        this.loadingSave = false
        throw new Error(error)
      } finally {
        this.$root.$emit('updateFunnel')
        this.$root.$emit('save-complete')
        this.cacheData()
      }
    },
    highlightLinkedItems(index) {
      const clickedItem = this.droppedItems[index]
      const directlyLinkedItems = new Set()
      const connectedLines = []

      this.lines.forEach((line) => {
        const startItem = this.droppedItems.find(
          (item) =>
            this.$refs.droppedItem[this.droppedItems.indexOf(item)] ===
            line.start
        )
        const endItem = this.droppedItems.find(
          (item) =>
            this.$refs.droppedItem[this.droppedItems.indexOf(item)] === line.end
        )

        if (endItem === clickedItem || startItem === clickedItem) {
          directlyLinkedItems.add(startItem)
          directlyLinkedItems.add(endItem)
          connectedLines.push(line)
        }
      })

      this.droppedItems.forEach((item, idx) => {
        if (directlyLinkedItems.has(item)) {
          this.$set(this.droppedItems[idx], 'highlighted', true)
        } else {
          this.$set(this.droppedItems[idx], 'highlighted', false)
        }
      })

      this.lines.forEach((line) => {
        if (connectedLines.includes(line)) {
          line.line.setOptions({ dash: { animation: true }, color: 'blue' })
        } else {
          line.line.setOptions({ path: 'grid', color: '#7a8696' })
        }
      })
    },

    deselectItem() {
      this.selectedItem = null
      this.isOverlayVisible = false
      this.$root.$emit('overlay-visibility-changed', this.isOverlayVisible)
      this.droppedItems.forEach((item, idx) => {
        this.$set(this.droppedItems[idx], 'highlighted', false)
      })

      this.lines.forEach((line) => {
        line.line.setOptions({ dash: false, color: '#7a8696' })
      })
    },
    isSelected(index) {
      return this.selectedItem === index
    },
    initializeInteract() {
      if (this.$refs.droppedItem && this.$refs.droppedItem.length) {
        this.$refs.droppedItem.forEach((el, index) => {
          const item = this.droppedItems[index]
          this.initializeInteractForItem(item)
        })
      }
    },
    getMetricClass(value) {
      if (value > 0) {
        return 'green-data'
      } else if (value < 0) {
        return 'red-data'
      } else {
        return 'gray-data'
      }
    },
    getMetricIcon(value) {
      if (value > 0) {
        return 'mdi-arrow-up'
      } else if (value < 0) {
        return 'mdi-arrow-down'
      } else {
        return '-'
      }
    },
    formatIntegrationName(name) {
      const formattedNames = {
        mailchimp: 'Mailchimp',
        active_campaign: 'Active Campaign',
        webhook: 'Webhook',
      }
      return formattedNames[name] || name
    },
    handleMenuChange(value) {
      this.selectedContent = value
      this.isMenuClosed = false
      this.pageRequests()
      this.$emit('menu-change', value)
    },
    zoomIn() {
      this.disableZoomOut = false
      this.deselectItem()
      if (this.zoomLevel < 2) {
        this.zoomLevel += 0.1
        this.disableZoomIn = this.zoomLevel >= 2
        this.$nextTick(() => {
          this.updateLinesPosition()
        })
      }
    },
    zoomOut() {
      this.disableZoomIn = false
      this.deselectItem()
      if (this.zoomLevel > 0.5) {
        this.zoomLevel -= 0.1
        this.disableZoomOut = this.zoomLevel <= 0.5
        this.$nextTick(() => {
          this.updateLinesPosition()
        })
      }
    },
    handleWheelEvent(event) {
      if (event.ctrlKey) {
        event.preventDefault()
        if (event.deltaY < 0) {
          this.zoomIn()
        } else if (event.deltaY > 0) {
          this.zoomOut()
        }
      }
    },
    handleKeydownEvent(event) {
      if (event.ctrlKey) {
        if (event.code === 'Equal' || event.code === 'NumpadAdd') {
          event.preventDefault()
          this.zoomIn()
        } else if (event.code === 'Minus' || event.code === 'NumpadSubtract') {
          event.preventDefault()
          this.zoomOut()
        }
      }
    },
    getMedian(values) {
      const sorted = [...values].sort((a, b) => a - b)
      const mid = Math.floor(sorted.length / 2)
      return sorted.length % 2 !== 0
        ? sorted[mid]
        : (sorted[mid - 1] + sorted[mid]) / 2
    },
    reset() {
      this.deselectItem()
      this.$nextTick(() => {
        const dragArea = this.$el.querySelector('.dragable-area')
        const zoomContainer = this.$el.querySelector('.zoom-container')
        if (!dragArea || !zoomContainer || !this.droppedItems?.length) return

        const centerVideo = this.findCenterMostVideo()

        if (centerVideo) {
          const targetX = centerVideo.x
          const targetY = centerVideo.y

          const screenCenterX = window.innerWidth / 2
          const screenCenterY = window.innerHeight / 2

          this.currentX = screenCenterX - targetX - 224
          this.currentY = screenCenterY - targetY - 52.5

          this.zoomLevel = 0.7
          zoomContainer.style.transform = 'scale(0.7)'
          dragArea.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
        } else {
          this.resetToGlobalCenter(dragArea, zoomContainer)
        }

        this.updateLinesPosition()
      })
    },
    findAndFocusItem() {
      this.$nextTick(() => {
        const dragArea = this.$el.querySelector('.dragable-area')
        const zoomContainer = this.$el.querySelector('.zoom-container')
        if (
          !dragArea ||
          !zoomContainer ||
          !this.droppedItems?.length ||
          !this.$route.query
        )
          return
        const videoFound = this.droppedItems.find(
          (row) => row.id === this.$route.query.droppedItem
        )

        if (videoFound) {
          const targetX = videoFound.x
          const targetY = videoFound.y

          const screenCenterX = window.innerWidth / 2
          const screenCenterY = window.innerHeight / 2

          this.currentX = screenCenterX - targetX - 224
          this.currentY = screenCenterY - targetY - 52.5

          this.zoomLevel = 0.7
          zoomContainer.style.transform = 'scale(0.7)'
          dragArea.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
        }
        this.updateLinesPosition()
      })
    },
    findCenterMostVideo() {
      if (!this.droppedItems?.length) return null

      const totalX = this.droppedItems.reduce((sum, item) => sum + item.x, 0)
      const totalY = this.droppedItems.reduce((sum, item) => sum + item.y, 0)

      const geometricCenterX = totalX / this.droppedItems.length
      const geometricCenterY = totalY / this.droppedItems.length

      let closestVideo = null
      let minDistance = Infinity

      this.droppedItems.forEach((item) => {
        const distance = Math.sqrt(
          Math.pow(item.x - geometricCenterX, 2) +
            Math.pow(item.y - geometricCenterY, 2)
        )

        if (distance < minDistance) {
          minDistance = distance
          closestVideo = item
        }
      })

      return closestVideo
    },

    resetToGlobalCenter(dragArea, zoomContainer) {
      const xValues = this.droppedItems.map((item) => item.x)
      const yValues = this.droppedItems.map((item) => item.y)

      const minX = Math.min(...xValues)
      const maxX = Math.max(...xValues)
      const minY = Math.min(...yValues)
      const maxY = Math.max(...yValues)

      const centerX = (minX + maxX) / 2
      const centerY = (minY + maxY) / 2

      this.currentX = centerX - 100
      this.currentY = centerY + 100
      this.zoomLevel = 0.7
      zoomContainer.style.transform = 'scale(0.7)'
      dragArea.style.transform = `translate(${centerX - 150}px, ${
        centerY + 150
      }px)`
    },
    fullscreen() {
      const elem = document.documentElement

      if (!document.fullscreenElement) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          // Firefox
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
          // Chrome, Safari and Opera
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          // IE/Edge
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          // Firefox
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          // Chrome, Safari and Opera
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          // IE/Edge
          document.msExitFullscreen()
        }
        this.deselectItem()
        this.updateLinesPosition()
      }
    },
    selectForLinking(item) {
      if (this.loadingSave) return
      this.removeWheel()
      this.deselectItem()
      this.selectedContent = 0
      this.isMenuClosed = false
      this.linkingItem = item
      this.handleOpenAddVideoDestiny(item)
    },
    async createLink(
      item1,
      item2,
      startAnchorClass = 'link-anchor',
      endAnchorClass = 'preview-anchor'
    ) {
      if (!window.LeaderLine) {
        console.error('LeaderLine is not loaded')
        return
      }

      const getElements = () => {
        const el1 =
          this.$refs.droppedItem?.[
            this.droppedItems.findIndex(
              (item) => item1?.video_external_id === item?.video_external_id
            )
          ]
        const el2 =
          this.$refs.droppedItem?.[
            this.droppedItems.findIndex(
              (item) => item2?.video_external_id === item?.video_external_id
            )
          ]
        const startAnchor = el1?.querySelector?.(`.${startAnchorClass}`)
        const endAnchor = el2?.querySelector?.(`.${endAnchorClass}`)

        return { el1, el2, startAnchor, endAnchor }
      }

      let retries = 10
      let el1, el2, startAnchor, endAnchor

      while (retries > 0) {
        await this.$nextTick()

        const result = getElements()
        el1 = result.el1
        el2 = result.el2
        startAnchor = result.startAnchor
        endAnchor = result.endAnchor

        if (el1 && el2 && startAnchor && endAnchor) break

        await new Promise((resolve) => setTimeout(resolve, 100)) // espera 100ms
        retries--
      }

      if (!el1 || !el2 || !startAnchor || !endAnchor) {
        console.warn('Não foi possível criar link: elementos não encontrados.')
        return
      }

      const line = new window.LeaderLine(startAnchor, endAnchor, {
        color: '#7a8696',
        size: 2,
        startPlug: 'disc',
        startSocket: 'right',
        endSocket: 'left',
        endPlug: 'arrow2',
        path: 'grid',
        zIndex: 1,
      })

      this.lines.push({ line, start: el1, end: el2 })
      this.$set(item1, 'linkedFrom', true)
      this.$set(item1, 'linkedToRight', true)
      this.updateZIndex()
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    setUppyLanguage(lang) {
      if (lang.includes('en')) {
        this.uppyLocale = English
      } else {
        this.uppyLocale = Portuguese
      }
      this.setUppyEventsOff()
      this.uppyUpdated++
      setTimeout(() => {
        this.setUppyEvents()
      }, 1000)
    },
    setUppyEventsOff() {
      this.uppy.off('file-added')
      this.uppy.off('upload-success')
      this.uppy.off('progress')
      this.uppy.off('restriction-failed')
      this.uppy.off('back-online')
      this.uppy.off('upload-error')
    },
    setUppyEvents() {
      // eslint-disable-next-line no-unused-vars
      this.uppy.on('upload-error', async (file, error, response) => {
        try {
          let err = error.toString()
          if (err.match('reached the maximum allowed')) {
            this.$root.$emit('onStorageSizeMax')
            this.$root.$emit('importUploadError')
            this.$root.$emit('forcePauseUploadList')
            if (!this.isFetchingPlanInfo) {
              const _this = this
              this.$root.$emit('fixUserLimit', true)
              this.isFetchingPlanInfo = true
              this.$root.$on('loadedUserLimitToUppy', () => {
                const type = err.includes('storage') ? 'storage' : 'traffic'
                _this.isFetchingPlanInfo = false

                if (_this.planInfo.subscription.status !== 'trialing') {
                  _this.$root.$emit('usageLimitModal', {
                    open: true,
                    type,
                    storagePlan: _this.planInfo?.limit?.storage_plan,
                  })
                } else if (_this.planInfo.subscription.status === 'trialing') {
                  _this.$root.$emit('ModalResetBillingCycle')
                }
              })
            }
          } else if (
            err.match('no space left') ||
            err.match('endpoint might be blocked')
          ) {
            this.swapUploadServer(file)
          }
        } catch (e) {
          this.UPDATE_GLOBAL_SNACKBAR({ open: true, text: `${e}` })
        }
      })
      this.uppy.on('file-added', (file) => {
        let storageKeys = Storage.getStorageKeys()
        for (let key of storageKeys) {
          if (key[0].includes('tus::tus-uppy')) {
            Storage.removeItem(key[0])
          }
        }
        //Set dos metadados em vídeos importados de outra  plataforma
        let id = ''
        if (file.meta.folder_id) {
          id = file.meta.folder_id
        } else {
          id = this.$route.params.id
        }
        const userId = this.$store.getters['session/userSub']
        const refreshToken = this.$store.state.user.refreshToken
        const authorization = 'Bearer ' + Storage.getItem('accessToken')
        const uploadType = file.isRemote ? 'companion' : 'direct'
        this.uppy.setFileMeta(file.id, {
          video_id: uuidv4(),
          folder_id: id,
          user_id: userId,
          refresh_token: refreshToken,
          authorization: authorization,
          upload_type: uploadType,
        })
        this.uploadFiles = this.uppy.getFiles()
        this.uploadOpened = true
        if (this.uploadPaused) {
          this.uppy.resumeAll()
        }
      })
      this.uppy.on('upload-success', (file) => {
        this.$root.$emit('fixUserLimit')
        const videoFormat = {
          title: file.name,
          id: file.meta.video_id,
          status: 'DRAFT',
          folder_id: file.meta.folder_id,
          updated_at: new Date().toISOString(),
        }
        this.uploadFiles = this.uppy.getFiles()
        let storagedVideosArray = Storage.getItem(
          `panda-queue-${this.$store.state.user.userInfo.sub}`
        )
        if (!storagedVideosArray) {
          Storage.setItem(
            `panda-queue-${this.$store.state.user.userInfo.sub}`,
            [videoFormat]
          )
        } else {
          storagedVideosArray.push(videoFormat)
          Storage.setItem(
            `panda-queue-${this.$store.state.user.userInfo.sub}`,
            storagedVideosArray
          )
        }
        setTimeout(() => {
          this.handleManualDrop(videoFormat, true)
        }, 300)
      })
      this.uppy.on('progress', (progress) => {
        this.uploadProgress = progress
        this.uploadFiles = this.uppy.getFiles()
      })
      this.uppy.on('restriction-failed', (file) => {
        if (file.extension === 'pdf') {
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            text: i18n.t('message.fileExtensionError'),
          })
        }
      })
      this.uppy.on('back-online', () => {
        this.uppy.retryAll()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.divider-vertical {
  width: 1px;
  height: 24px;
  background: varFigma(neutral-95-lightest);
  margin-left: 16px;
  margin-right: 16px;
}
::v-deep .page-view__header {
  z-index: 1;
}
/* Outras regras de estilo existentes */

html {
  overflow: hidden;
}

.internal-divider.v-divider {
  width: 87%;
  margin-left: 20px;
}

.main-content {
  //   padding-top: 60px;
  display: flex;
  //   height: calc(100vh - 60px);
}
.main-scroll {
  border: none !important;
}
.convertingPreview {
  display: flex;
  height: 54px;
  padding: 0px 6px 0px 7px;
  justify-content: center;
  align-items: center;
  background: linear-gradient(108deg, #d7dde6 0%, #b7c2d2 100.22%);
}
.convertingPreviewList {
  display: flex;
  padding: 0px 6px 0px 7px;
  border-radius: 6px;
  height: 50px;
  width: 100px;
  justify-content: center;
  align-items: center;
  background: linear-gradient(108deg, #d7dde6 0%, #b7c2d2 100.22%);
}
.convertingText {
  color: var(--Gray-900, #494b4f);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
}
.lenghtConvertingText {
  color: var(--Gray-500, #7a8696);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.loader-one {
  display: flex;
  width: 2px;
  height: 2px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5-one 1s infinite linear alternate;
  top: 3px;
  left: 6px;
  position: relative;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block; /* ou inline-block se preferir */
  max-width: 100%; /* ou um valor fixo como 200px */
}
.loader-two {
  display: flex;
  width: 2px;
  height: 2px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5-two 1s infinite linear alternate;
  top: 10px;
  left: 6px;
  position: relative;
}

@keyframes l5-one {
  0% {
    box-shadow: 4px 0 #000, -4px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow: 4px 0 #000, -4px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow: 4px 0 #0002, -4px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow: 4px 0 #0002, -4px 0 #000;
    background: #000;
  }
}

@keyframes l5-two {
  0% {
    box-shadow: 4px 0 #7a8696, -4px 0 #414549;
    background: #7a8696;
  }
  33% {
    box-shadow: 4px 0 #7a8696, -4px 0 #414549;
    background: #414549;
  }
  66% {
    box-shadow: 4px 0 #414549, -4px 0 #7a8696;
    background: #414549;
  }
  100% {
    box-shadow: 4px 0 #414549, -4px 0 #7a8696;
    background: #7a8696;
  }
}
.mailchimp-container {
  display: flex;
  align-items: center;
  height: 30px;
  border-radius: 3.81px;
  border: 0.953px solid varFigma(neutral-70);
  background: varFigma(neutral-90);
}
.first-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  width: 47px;
  border-radius: 50px;
  background: var(--Details-Fluor, #b3ff53);
  color: #00f;
  font-size: 9px;
  font-weight: 600;
}
.funnel-container {
  display: flex;
  flex-direction: column;
}

::v-deep .main-scroll[data-v-55a76cbe] {
  height: 100vh;
}

::v-deep .t-container {
  height: 65vh !important;
}

.sidebar-menu {
  position: relative;
  flex-shrink: 0;
}
.dragged-item {
  opacity: 1;
  background: #e0e0e0;
  cursor: grabbing;
}

.content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: varFigma(neutral-99);
}
.option-content {
  display: flex;
  flex-grow: 1;
}
.upload-container {
  margin-top: auto;
}
.uploadButton {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--Primary-800, #1d0092);
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  cursor: pointer;
}

.addInteraction-text {
  overflow: hidden;
  color: varFigma(neutral-30-base);
  font-size: 13.336px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.addInteraction-text:hover {
  color: var(--Primary-800, #1d0092);
  cursor: pointer;
}

.modal-actions {
  padding-top: 64px !important;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: var(--Box-Radius, 16px);
  align-self: stretch;
}

.cancel-btn {
  display: flex;
  height: 48px;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 32px;
  border: 1px solid var(--Gray-400, #b7c2d2);
}

.remove-btn {
  display: flex;
  height: 48px;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 32px;
  color: white;
  background: var(--Error-800, #a81914);
}

.cta-title {
  color: varFigma(neutral-10-darker);
  font-family: Rubik;
  gap: 8px;
  font-size: 12px;
  padding-left: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
  text-transform: uppercase;
  align-items: center;
}
.cta-action {
  justify-content: end;
  display: flex;
  overflow: hidden;
  color: varFigma(neutral-30-base);
  text-align: right;
  text-overflow: ellipsis;
  align-items: center;
  font-size: 13.336px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  padding-right: 20px;
}
.empty-state-title {
  color: var(--Base-Black, #363940);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
}

.empty-state-desc {
  color: var(--Gray-500, #7a8696);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 135.714% */
}

.content-box {
  border-right: 1px solid var(--Gray-200, #e8ebf1);
  background: #fff;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0px;
  left: 80px;
  transition: transform 0.3s ease-in-out;
  transform: translateX(0);
}
.dropped-item.highlighted {
  border-radius: 16px;
  border: 1px solid var(--Primary-800, #1d0092);
  box-shadow: 0px 25px 50px 0px rgba(0, 0, 0, 0.25);
  z-index: 1000 !important;
}
.line-analytics {
  display: inline-flex;
  padding-left: 8px;
  align-items: center;
  gap: 8px;
  height: 23px;
  border-radius: 4px;
  border: 1px solid var(--Gray-200, #e8ebf1);
  background: var(--Background, #f8f9fa);
  position: relative;
  right: -20px;
  z-index: 2000 !important;
}
.line-analytics-percent {
  background: var(--Gray-100, #f0f2f8);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 35px;
  height: 23px;
  border-left: 1px solid var(--Gray-200, #e8ebf1);
  display: flex;
  padding: 8px 4px;
  font-size: 10px;
  justify-content: center;
  align-items: center;
}
.line-analytics-value {
  background: var(--Gray-100, #f0f2f8);
  border-radius: 4px;
  display: flex;
  font-size: 10px;
  justify-content: center;
  align-items: center;
}
.menu-item {
  display: flex;
  align-items: flex-start;
}
.brand-95-lighter {
  background: varFigma(brand-95-lighter);
}
.v-menu__content {
  margin-top: 35px;
  border-radius: 8px !important;
  box-shadow: 0px 4px 34px -10px rgba(0, 0, 0, 0.15) !important;
}
.dropped-menu {
  border-radius: var(--Box-Radius, 16px) !important;
  border: 1px solid var(--Gray-300, #d7dde6) !important;
  background: var(--Base-White, #fff) !important;
  box-shadow: 0px 4px 34px -10px rgba(0, 0, 0, 0.15) !important;
}
.content-box.closed {
  transform: translateX(-100%);
}
.overlay {
  position: fixed;
  top: -2500px;
  left: -2500px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.embed-overlay {
  position: fixed;
  top: -2500px;
  left: -2500px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  z-index: 7;
}

.modal-title {
  color: var(--Base-Black, #363940);
  text-align: center;
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  /* Title/Large */
  font-family: Manrope;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 26.4px */
  letter-spacing: -0.44px;
}

.modal-desc {
  color: var(--Base-Black, #363940);
  text-align: center;
  /* Subtitle/Medium */
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.07px;
}

.dragable-area {
  background-color: varFigma(neutral-99);
  position: relative;
}

.tooltip {
  display: none;
  width: 167px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(--Base-Black, #363940);
  color: var(--M3-sys-light-inverse-on-surface, #f5eff7);
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 18px */
  position: absolute;
  z-index: 1000;
  top: -90px;
  left: 145%;
  transform: translateX(-50%);
}

.line-analytics:hover .tooltip {
  display: flex;
}

.dropped-item.selected {
  border-radius: 16px;
  border: 1px solid var(--Primary-800, #1d0092);
  box-shadow: 0px 25px 50px 0px rgba(0, 0, 0, 0.25);
  z-index: 1000 !important;
}
.dropped-item {
  position: absolute;
  width: 448px;
  min-height: 105px;
  border-radius: 16px;
  border: 1px solid varFigma(neutral-95-lightest);
  background: varFigma(neutral-100-white);
  display: flex;
  cursor: pointer !important;
  z-index: 0;
}

.dropped-item:active {
  cursor: move !important;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.drag-drop .searchVideosMenuContext {
  cursor: pointer;
}
.searchVideosMenuContext.video-item {
  cursor: move;
}
.searchVideosMenuContext.folder-item {
  cursor: pointer;
}

.analytics-title {
  color: var(--Gray-600, #717984);
  font-weight: 500;
  padding-bottom: 5px;
  line-height: 150%; /* 18px */
  font-size: 12px;
}
.analytics-data {
  color: var(--Base-Black, #363940);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}

.link-field {
  border-radius: 4px;
  display: flex;
  padding: 0px 4px;
  align-items: center;
  align-self: stretch;
  border: 1px solid varFigma(neutral-70);
  background: varFigma(neutral-90);
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.analytics-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  min-height: 80px; /* ajuste conforme necessário */
}

::v-deep .t-header {
  display: none;
}

.plus-icon {
  display: flex;
  color: #1d0092;
  align-self: end;
  cursor: pointer;
  margin-left: 24px;
  width: 40px;
  height: 40px;
  padding: 8px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 26px;
  background: var(--Gray-200, #e8ebf1);
}

.link-plus-icon {
  display: flex;
  color: #494b4f;
  align-self: center;
  cursor: pointer;
  position: relative;
  left: -13px;
  padding: 6px;
  flex-shrink: 0;
  border-radius: 8px;
  background: varFigma(neutral-95-lightest);
}

.link-plus-icon:hover {
  img {
    filter: invert(13%) sepia(84%) saturate(4495%) hue-rotate(204deg)
      brightness(60%) contrast(127%);
  }
}

.floating-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
  padding: 12px 18px;
  border-radius: var(--Box-Margem-horizontal, 32px);
  border: 1px solid var(--Gray-300, #d7dde6);
  background: var(--Base-White, #fff);
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  color: var(--Gray-500, #7a8696);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.floating-menu button {
  background: none;
  border: none;
  cursor: pointer;
}
.empty-state-plus-icon {
  color: #1d0092;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 8px;
  border-radius: 26px;
  background: var(--Gray-200, #e8ebf1);
}

.anchor {
  position: absolute;
  width: 0;
  height: 0;
}
.border-bottom {
  border-bottom: 1px solid varFigma(neutral-95-lightest) !important;
}
.preview-anchor {
  top: 0;
  left: 100%;
}
.link-anchor {
  top: 50%;
  right: 100%;
}
.button-link-anchor {
  top: 50%;
  right: 100%;
}
.quiz-link-anchor {
  top: 50%;
  right: 100%;
}
.bottom-left-radius {
  border-bottom-left-radius: 16px;
}

.empty-state {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--Gray-600, #717984);
  z-index: 10;
  background: varFigma(neutral-99);
}

.empty-state p {
  margin: 0;
  padding: 8px;
}

.funnel-container,
.zoom-container,
.dragable-area,
.overlay,
.watching-preview-overlay,
.embed-overlay {
  width: 15000px;
  height: 15000px;
}
.video-title {
  color: varFigma(neutral-10-darker);
  font-size: 17.146px;
  height: 62px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
}
</style>

<style>
.initial-span-video {
  color: varFigma(brand-20-darkest);
  font-family: Rubik;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.analytics-firstLine {
  justify-content: space-between;
  display: flex;
}
.analytics-container {
  display: flex;
  width: 280px;
  padding: 16px 20px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #e5e7eb !important;
  background: #fff;
}

.analytics-title {
  color: #7a8696;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.analytics-data {
  color: #363940;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
/* .hide-leader-lines .leader-line {
  display: none;
} */

.remove-btn-funnel {
  color: var(--Base-Black, #cc2c26);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
